"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.symbolLookupObject = void 0;

/**
 * data obtain from coinmarketcap api
 * end point is latest listing
 */
var symbolLookupObject = {
  '867': '867',
  Bitcoin: 'BTC',
  Ethereum: 'ETH',
  'Binance Coin': 'BNB',
  Cardano: 'ADA',
  Tether: 'USDT',
  XRP: 'XRP',
  Solana: 'SOL',
  Polkadot: 'DOT',
  'USD Coin': 'USDC',
  Dogecoin: 'DOGE',
  Terra: 'LUNA',
  Uniswap: 'UNI',
  'Binance USD': 'BUSD',
  Avalanche: 'AVAX',
  Litecoin: 'LTC',
  'Wrapped Bitcoin': 'WBTC',
  'SHIBA INU': 'SHIB',
  Chainlink: 'LINK',
  'Bitcoin Cash': 'BCH',
  Algorand: 'ALGO',
  Polygon: 'MATIC',
  Stellar: 'XLM',
  Filecoin: 'FIL',
  'Internet Computer': 'ICP',
  'Axie Infinity': 'AXS',
  Cosmos: 'ATOM',
  VeChain: 'VET',
  'Ethereum Classic': 'ETC',
  TRON: 'TRX',
  Dai: 'DAI',
  'FTX Token': 'FTT',
  Tezos: 'XTZ',
  THETA: 'THETA',
  'Bitcoin BEP2': 'BTCB',
  Fantom: 'FTM',
  Hedera: 'HBAR',
  Monero: 'XMR',
  Elrond: 'EGLD',
  'Crypto.com Coin': 'CRO',
  PancakeSwap: 'CAKE',
  EOS: 'EOS',
  eCash: 'XEC',
  Klaytn: 'KLAY',
  Aave: 'AAVE',
  IOTA: 'MIOTA',
  'NEAR Protocol': 'NEAR',
  Quant: 'QNT',
  Waves: 'WAVES',
  'The Graph': 'GRT',
  'Bitcoin SV': 'BSV',
  Neo: 'NEO',
  Kusama: 'KSM',
  TerraUSD: 'UST',
  'UNUS SED LEO': 'LEO',
  Stacks: 'STX',
  Harmony: 'ONE',
  BitTorrent: 'BTT',
  Maker: 'MKR',
  'OMG Network': 'OMG',
  Helium: 'HNT',
  Amp: 'AMP',
  Chiliz: 'CHZ',
  Dash: 'DASH',
  Celo: 'CELO',
  Arweave: 'AR',
  Compound: 'COMP',
  Decred: 'DCR',
  THORChain: 'RUNE',
  Revain: 'REV',
  Holo: 'HOT',
  NEM: 'XEM',
  'Theta Fuel': 'TFUEL',
  Zcash: 'ZEC',
  'XDC Network': 'XDC',
  ICON: 'ICX',
  Decentraland: 'MANA',
  Celsius: 'CEL',
  TrueUSD: 'TUSD',
  Qtum: 'QTUM',
  'Enjin Coin': 'ENJ',
  SushiSwap: 'SUSHI',
  dYdX: 'DYDX',
  'yearn.finance': 'YFI',
  'Bitcoin Gold': 'BTG',
  'Huobi Token': 'HT',
  'Curve DAO Token': 'CRV',
  Mina: 'MINA',
  Flow: 'FLOW',
  Mdex: 'MDX',
  'Perpetual Protocol': 'PERP',
  Zilliqa: 'ZIL',
  Ravencoin: 'RVN',
  Synthetix: 'SNX',
  'Basic Attention Token': 'BAT',
  Ren: 'REN',
  Serum: 'SRM',
  renBTC: 'RENBTC',
  OKB: 'OKB',
  IOST: 'IOST',
  'Pax Dollar': 'USDP',
  Telcoin: 'TEL',
  Nexo: 'NEXO',
  'Celer Network': 'CELR',
  'KuCoin Token': 'KCS',
  Siacoin: 'SC',
  Bancor: 'BNT',
  '0x': 'ZRX',
  Horizen: 'ZEN',
  Audius: 'AUDIO',
  Secret: 'SCRT',
  Ontology: 'ONT',
  DigiByte: 'DGB',
  Nano: 'NANO',
  Raydium: 'RAY',
  'Voyager Token': 'VGX',
  Ankr: 'ANKR',
  IoTeX: 'IOTX',
  SwissBorg: 'CHSB',
  'The Sandbox': 'SAND',
  'SKALE Network': 'SKL',
  UMA: 'UMA',
  'Function X': 'FX',
  'Neutrino USD': 'USDN',
  'Fetch.ai': 'FET',
  Golem: 'GLM',
  Dent: 'DENT',
  Kava: 'KAVA',
  '1inch': '1INCH',
  WAX: 'WAXP',
  Loopring: 'LRC',
  HUSD: 'HUSD',
  'WOO Network': 'WOO',
  DigitalBits: 'XDB',
  'Ocean Protocol': 'OCEAN',
  Numeraire: 'NMR',
  'Bitcoin Standard Hashrate Token': 'BTCST',
  Gnosis: 'GNO',
  Storj: 'STORJ',
  COTI: 'COTI',
  Polymath: 'POLY',
  'Reserve Rights': 'RSR',
  'Alpha Finance Lab': 'ALPHA',
  'Bitcoin Diamond': 'BCD',
  Swipe: 'SXP',
  'Fei Protocol': 'FEI',
  'Nervos Network': 'CKB',
  Lisk: 'LSK',
  XYO: 'XYO',
  WINkLink: 'WIN',
  Verge: 'XVG',
  Livepeer: 'LPT',
  WazirX: 'WRX',
  'VeThor Token': 'VTHO',
  BakeryToken: 'BAKE',
  MediBloc: 'MED',
  aelf: 'ELF',
  'Injective Protocol': 'INJ',
  'Badger DAO': 'BADGER',
  Ardor: 'ARDR',
  Conflux: 'CFX',
  Reef: 'REEF',
  Unibright: 'UBT',
  Civic: 'CVC',
  Ergo: 'ERG',
  SingularityNET: 'AGIX',
  'PAX Gold': 'PAXG',
  StormX: 'STMX',
  Venus: 'XVS',
  'iExec RLC': 'RLC',
  'Oasis Network': 'ROSE',
  'Ontology Gas': 'ONG',
  Hive: 'HIVE',
  Status: 'SNT',
  'Energy Web Token': 'EWT',
  GateToken: 'GT',
  Velas: 'VLX',
  Prometeus: 'PROM',
  Stratis: 'STRAX',
  ASD: 'ASD',
  'Origin Protocol': 'OGN',
  Verasity: 'VRA',
  Orbs: 'ORBS',
  Casper: 'CSPR',
  'Band Protocol': 'BAND',
  MyNeighborAlice: 'ALICE',
  Augur: 'REP',
  Constellation: 'DAG',
  MaidSafeCoin: 'MAID',
  NKN: 'NKN',
  Ark: 'ARK',
  Dero: 'DERO',
  Request: 'REQ',
  Cartesi: 'CTSI',
  Enzyme: 'MLN',
  Steem: 'STEEM',
  Orchid: 'OXT',
  Metal: 'MTL',
  FUNToken: 'FUN',
  MVL: 'MVL',
  OriginTrail: 'TRAC',
  HEX: 'HEX',
  'Lido stETH': 'STETH',
  'Bitcoin Cash ABC': 'BCHA',
  'Wrapped BNB': 'WBNB',
  'Huobi BTC': 'HBTC',
  Symbol: 'XYM',
  Creditcoin: 'CTC',
  ECOMI: 'OMI',
  'The Transfer Token': 'TTT',
  yOUcash: 'YOUC',
  'Counos X': 'CCXX',
  SafeMoon: 'SAFEMOON',
  NXM: 'NXM',
  'Venus BNB': 'vBNB',
  DeFiChain: 'DFI',
  'Liquity USD': 'LUSD',
  WhiteCoin: 'XWC',
  LINK: 'LN',
  Alitas: 'ALT',
  Coin98: 'C98',
  Gala: 'GALA',
  'INO COIN': 'INO',
  Moonriver: 'MOVR',
  'Yield Guild Games': 'YGG',
  'Pundi X[new]': 'PUNDIX',
  'Convex Finance': 'CVX',
  BitDAO: 'BIT',
  'Pirate Chain': 'ARRR',
  Illuvium: 'ILV',
  Persistence: 'XPRT',
  Tribe: 'TRIBE',
  'Orbit Chain': 'ORC',
  'Trust Wallet Token': 'TWT',
  LUKSO: 'LYXe',
  Frax: 'FRAX',
  'Anchor Protocol': 'ANC',
  Electroneum: 'ETN',
  'Bitpanda Ecosystem Token': 'BEST',
  Kadena: 'KDA',
  'Akash Network': 'AKT',
  'Rari Governance Token': 'RGT',
  'Rocket Pool': 'RPL',
  MOBOX: 'MBOX',
  KOK: 'KOK',
  Radicle: 'RAD',
  'Kyber Network Crystal v2': 'KNC',
  Bonfida: 'FIDA',
  'Beyond Protocol': 'BP',
  Telos: 'TLOS',
  'Mask Network': 'MASK',
  HedgeTrade: 'HEDG',
  PEAKDEFI: 'PEAK',
  'Mango Markets': 'MNGO',
  TitanSwap: 'TITAN',
  'Shiden Network': 'SDN',
  'Chia Network': 'XCH',
  'Adventure Gold': 'AGLD',
  'Dawn Protocol': 'DAWN',
  'Bifrost (BFC)': 'BFC',
  SuperRare: 'RARE',
  'Keep Network': 'KEEP',
  'Orion Protocol': 'ORN',
  Alchemix: 'ALCX',
  'Venus BTC': 'vBTC',
  Sapphire: 'SAPP',
  Anyswap: 'ANY',
  'Mirror Protocol': 'MIR',
  Ellipsis: 'EPS',
  Linear: 'LINA',
  'Morpheus.Network': 'MRPH',
  'RSK Infrastructure Framework': 'RIF',
  'Phala Network': 'PHA',
  'Toko Token': 'TKO',
  PlayDapp: 'PLA',
  'Star Atlas': 'ATLAS',
  NuCypher: 'NU',
  'Alchemy Pay': 'ACH',
  QuarkChain: 'QKC',
  WEMIX: 'WEMIX',
  Everipedia: 'IQ',
  'Bloomzed Loyalty Club Ticket': 'BLCT',
  TomoChain: 'TOMO',
  IDEX: 'IDEX',
  'Gemini Dollar': 'GUSD',
  Aragon: 'ANT',
  CRYPTO20: 'C20',
  sUSD: 'SUSD',
  Syntropy: 'NOIA',
  AllianceBlock: 'ALBT',
  'Star Atlas DAO': 'POLIS',
  'Alien Worlds': 'TLM',
  Syscoin: 'SYS',
  Centrifuge: 'CFG',
  JUST: 'JST',
  Utrust: 'UTK',
  Wanchain: 'WAN',
  API3: 'API3',
  Powerledger: 'POWR',
  'Standard Tokenization Protocol': 'STPT',
  Rally: 'RLY',
  Polkastarter: 'POLS',
  'Ribbon Finance': 'RBN',
  'Automata Network': 'ATA',
  Sentinel: 'DVPN',
  TROY: 'TROY',
  Strike: 'STRK',
  'Molecular Future': 'MOF',
  'Smooth Love Potion': 'SLP',
  DerivaDAO: 'DDX',
  BORA: 'BORA',
  Presearch: 'PRE',
  'Render Token': 'RNDR',
  'DFI.Money': 'YFII',
  dKargo: 'DKA',
  'Clover Finance': 'CLV',
  Ultra: 'UOS',
  'Travala.com': 'AVA',
  'ApeSwap Finance': 'BANANA',
  'Alpaca Finance': 'ALPACA',
  Rakon: 'RKN',
  'Venus ETH': 'vETH',
  DODO: 'DODO',
  'Revolution Populi': 'RVP',
  Balancer: 'BAL',
  Vai: 'VAI',
  Proton: 'XPR',
  MATH: 'MATH',
  'Wrapped NCG (Nine Chronicles Gold)': 'WNCG',
  Chromia: 'CHR',
  'USDX [Kava]': 'USDX',
  'Sun (New)': 'SUN',
  'Vulcan Forged PYR': 'PYR',
  'RSK Smart Bitcoin': 'RBTC',
  'Uquid Coin': 'UQC',
  MCO: 'MCO',
  Oxygen: 'OXY',
  Hxro: 'HXRO',
  Metadium: 'META',
  BitShares: 'BTS',
  Klever: 'KLV',
  Kin: 'KIN',
  Komodo: 'KMD',
  Zenon: 'ZNN',
  'Venus XVS': 'vXVS',
  QuickSwap: 'QUICK',
  KardiaChain: 'KAI',
  'ZB Token': 'ZB',
  Sologenic: 'SOLO',
  Splintershards: 'SPS',
  'Ethernity Chain': 'ERN',
  'Hifi Finance': 'MFT',
  'Shyft Network': 'SHFT',
  'LGCY Network': 'LGCY',
  Newscrypto: 'NWC',
  MXC: 'MXC',
  'Sport and Leisure': 'SNL',
  Elitium: 'EUM',
  IRISnet: 'IRIS',
  'NewYork Exchange': 'NYE',
  'Ampleforth Governance Token': 'FORTH',
  'MX Token': 'MX',
  BinaryX: 'BNX',
  WHALE: 'WHALE',
  'Frax Share': 'FXS',
  SafePal: 'SFP',
  Solanium: 'SLIM',
  'Loom Network': 'LOOM',
  Streamr: 'DATA',
  'DAO Maker': 'DAO',
  'Wilder World': 'WILD',
  RAMP: 'RAMP',
  BarnBridge: 'BOND',
  'Terra Virtua Kolect': 'TVK',
  'Thunder Token': 'TT',
  'Harvest Finance': 'FARM',
  'STASIS EURO': 'EURS',
  'cVault.finance': 'CORE',
  Hathor: 'HTR',
  CertiK: 'CTK',
  'ARPA Chain': 'ARPA',
  Gitcoin: 'GTC',
  Tranchess: 'CHESS',
  'Venus USDC': 'vUSDC',
  ZKSwap: 'ZKS',
  Sora: 'XOR',
  'ABBC Coin': 'ABBC',
  'PAC Protocol': 'PAC',
  ankrETH: 'aEth',
  Litentry: 'LIT',
  Carry: 'CRE',
  Chimpion: 'BNANA',
  ADAPad: 'ADAPAD',
  MonaCoin: 'MONA',
  'Haven Protocol': 'XHV',
  Rarible: 'RARI',
  Hegic: 'HEGIC',
  Gas: 'GAS',
  'Dvision Network': 'DVI',
  SifChain: 'erowan',
  'Sentinel Protocol': 'UPP',
  'Bella Protocol': 'BEL',
  'MCDEX Token': 'MCB',
  TokenPocket: 'TPT',
  'Celo Dollar': 'CUSD',
  BSCPAD: 'BSCPAD',
  Blox: 'CDT',
  Strong: 'STRONG',
  XeniosCoin: 'XNC',
  Firo: 'FIRO',
  Divi: 'DIVI',
  Ampleforth: 'AMPL',
  'e-Radix': 'EXRD',
  Aavegotchi: 'GHST',
  Velo: 'VELO',
  Tellor: 'TRB',
  'Wrapped NXM': 'WNXM',
  Akropolis: 'AKRO',
  'bZx Protocol': 'BZRX',
  district0x: 'DNT',
  'Lido DAO Token': 'LDO',
  LCX: 'LCX',
  XSGD: 'XSGD',
  Aergo: 'AERGO',
  'Deeper Network': 'DPR',
  GameFi: 'GAFI',
  'Decentral Games': 'DG',
  'Tokenlon Network Token': 'LON',
  Energi: 'NRG',
  'MiL.k': 'MLK',
  Centrality: 'CENNZ',
  'inSure DeFi': 'SURE',
  Refereum: 'RFR',
  Aion: 'AION',
  'Alpha Quark Token': 'AQT',
  'Cream Finance': 'CREAM',
  TrustSwap: 'SWAP',
  Frontier: 'FRONT',
  Elastos: 'ELA',
  Bytom: 'BTM',
  'LTO Network': 'LTO',
  Hydra: 'HYDRA',
  NFTX: 'NFTX',
  ReddCoin: 'RDD',
  KeeperDAO: 'ROOK',
  BNBPay: 'BPAY',
  HUNT: 'HUNT',
  'MANTRA DAO': 'OM',
  RChain: 'REV',
  Contentos: 'COS',
  Flux: 'FLUX',
  'Beefy.Finance': 'BIFI',
  Groestlcoin: 'GRS',
  AstroSwap: 'ASTRO',
  Handshake: 'HNS',
  'MARINADE STAKED SOL': 'MSOL',
  ShareToken: 'SHR',
  'Paris Saint-Germain Fan Token': 'PSG',
  Humanscape: 'HUM',
  Beam: 'BEAM',
  RMRK: 'RMRK',
  'Burger Swap': 'BURGER',
  Waltonchain: 'WTC',
  SuperFarm: 'SUPER',
  'Kava Lend': 'HARD',
  'Dogelon Mars': 'ELON',
  VideoCoin: 'VID',
  DIA: 'DIA',
  xDai: 'STAKE',
  Qcash: 'QC',
  Bluzelle: 'BLZ',
  'Darma Cash': 'DMCH',
  Kleros: 'PNK',
  Define: 'DFA',
  VerusCoin: 'VRSC',
  'Aleph.im': 'ALEPH',
  'Seedify.fund': 'SFUND',
  Flamingo: 'FLM',
  'AdEx Network': 'ADX',
  Propy: 'PRO',
  DAD: 'DAD',
  'YIELD App': 'YLD',
  PowerPool: 'CVP',
  'Rai Reflex Index': 'RAI',
  'BEPRO Network': 'BEPRO',
  'Tornado Cash': 'TORN',
  'Steem Dollars': 'SBD',
  Phantasma: 'SOUL',
  Liquity: 'LQTY',
  Marlin: 'POND',
  Karura: 'KAR',
  'Kava Swap': 'SWP',
  MovieBloc: 'MBL',
  'Dego Finance': 'DEGO',
  FirmaChain: 'FCT',
  'TABOO TOKEN': 'TABOO',
  'FIO Protocol': 'FIO',
  BASIC: 'BASIC',
  Lightning: 'LIGHT',
  'Tiger King': 'TKING',
  EFFORCE: 'WOZX',
  PARSIQ: 'PRQ',
  GlitzKoin: 'GTN',
  MultiVAC: 'MTV',
  APENFT: 'NFT',
  'BTU Protocol': 'BTU',
  Keep3rV1: 'KP3R',
  GNY: 'GNY',
  'Neutrino Token': 'NSBT',
  KARMA: 'KARMA',
  Bytecoin: 'BCN',
  'FC Barcelona Fan Token': 'BAR',
  TrueFi: 'TRU',
  'GoMining token': 'GMT',
  Ariva: 'ARV',
  SUKU: 'SUKU',
  'Apollo Currency': 'APL',
  unFederalReserve: 'eRSDL',
  Dock: 'DOCK',
  'Moss Coin': 'MOC',
  Covalent: 'CQT',
  Auto: 'AUTO',
  MetisDAO: 'METIS',
  'Bounce Token': 'AUCTION',
  CVCoin: 'CVN',
  'Dusk Network': 'DUSK',
  'Manchester City Fan Token': 'CITY',
  'Super Zero Protocol': 'SERO',
  CUTcoin: 'CUT',
  'Venus BUSD': 'vBUSD',
  DigixDAO: 'DGD',
  Valobit: 'VBIT',
  Counterparty: 'XCP',
  Metronome: 'MET',
  Dragonchain: 'DRGN',
  AXEL: 'AXEL',
  GameZone: 'GZONE',
  'Aidos Kuneen': 'ADK',
  BabySwap: 'BABY',
  'Boson Protocol': 'BOSON',
  NULS: 'NULS',
  CargoX: 'CXO',
  'BitMart Token': 'BMX',
  OpenOcean: 'OOE',
  Glitch: 'GLCH',
  'Crust Network': 'CRU',
  'Skey Network': 'SKEY',
  PIVX: 'PIVX',
  'Smartlands Network': 'SLT',
  ForTube: 'FOR',
  Polkadex: 'PDEX',
  'Belt Finance': 'BELT',
  'VIDT Datalink': 'VIDT',
  Nimiq: 'NIM',
  AhaToken: 'AHT',
  Maro: 'MARO',
  SingularityDAO: 'SDAO',
  'WOM Protocol': 'WOM',
  StarTerra: 'STT',
  Edgeware: 'EDG',
  'RedFOX Labs': 'RFOX',
  Mithril: 'MITH',
  CUDOS: 'CUDOS',
  'Soda Coin': 'SOC',
  ZIMBOCASH: 'ZASH',
  Nexus: 'NXS',
  'saffron.finance': 'SFI',
  ChainX: 'PCX',
  'Permission Coin': 'ASK',
  VIMworld: 'VEED',
  LATOKEN: 'LA',
  'Aragon Court': 'ANJ',
  'Poseidon Network': 'QQQ',
  'Invictus Hyperion Fund': 'IHF',
  'Bitrue Coin': 'BTR',
  'Impossible Decentralized Incubator Access': 'IDIA',
  Quantstamp: 'QSP',
  Aurox: 'URUS',
  Selfkey: 'KEY',
  'Unifi Protocol DAO': 'UNFI',
  SpiritSwap: 'SPIRIT',
  DeXe: 'DEXE',
  GXChain: 'GXC',
  'Raiden Network Token': 'RDN',
  'AMO Coin': 'AMO',
  Populous: 'PPT',
  'Spartan Protocol': 'SPARTA',
  'Atari Token': 'ATRI',
  MAPS: 'MAPS',
  Shopping: 'SPI',
  MimbleWimbleCoin: 'MWC',
  'Efinity Token': 'EFI',
  'PAID Network': 'PAID',
  'mStable USD': 'MUSD',
  'Polychain Monsters': 'PMON',
  WELL: 'WELL',
  Fusion: 'FSN',
  Safe: 'SAFE',
  PlatonCoin: 'PLTC',
  'PERL.eco': 'PERL',
  'Hoge Finance': 'HOGE',
  VITE: 'VITE',
  BENQI: 'QI',
  'Freeway Token': 'FWT',
  'CoinEx Token': 'CET',
  'v.systems': 'VSYS',
  DEXTools: 'DEXT',
  PolkaFoundry: 'PKF',
  CumRocket: 'CUMMIES',
  Cortex: 'CTXC',
  Eden: 'EDN',
  Ultiledger: 'ULT',
  'Lattice Token': 'LTX',
  FaraLand: 'FARA',
  'Hacken Token': 'HAI',
  TerraKRW: 'KRT',
  Samoyedcoin: 'SAMO',
  'Wing Finance': 'WING',
  StableXSwap: 'STAX',
  'Ferrum Network': 'FRM',
  REVV: 'REVV',
  Rubic: 'RBC',
  Oxen: 'OXEN',
  'Umbrella Network': 'UMB',
  'Solrise Finance': 'SLRS',
  'GET Protocol': 'GET',
  PIBBLE: 'PIB',
  'Reflexer Ungovernance Token': 'FLX',
  Kylin: 'KYL',
  Everest: 'ID',
  'Student Coin': 'STC',
  ZEON: 'ZEON',
  GoChain: 'GO',
  'Phoenix Global': 'PHB',
  CoinLoan: 'CLT',
  'Vega Protocol': 'VEGA',
  'APY.Finance': 'APY',
  Convergence: 'CONV',
  Grin: 'GRIN',
  'DxChain Token': 'DX',
  AirSwap: 'AST',
  Bankera: 'BNK',
  'Pepe Cash': 'PEPECASH',
  pNetwork: 'PNT',
  Rainicorn: 'RAINI',
  Aeternity: 'AE',
  'AIOZ Network': 'AIOZ',
  DOGGY: 'DOGGY',
  'Ethereum Push Notification Service': 'PUSH',
  Ternoa: 'CAPS',
  FIBOS: 'FO',
  Hiblocks: 'HIBS',
  UniLend: 'UFT',
  Arianee: 'ARIA20',
  'DSLA Protocol': 'DSLA',
  Particl: 'PART',
  NFTb: 'NFTB',
  WaykiChain: 'WICC',
  'Venus USDT': 'vUSDT',
  Cindicator: 'CND',
  'Atletico De Madrid Fan Token': 'ATM',
  Vertcoin: 'VTC',
  'Bitball Treasure': 'BTRS',
  Lotto: 'LOTTO',
  BABB: 'BAX',
  Massnet: 'MASS',
  Unisocks: 'SOCKS',
  Cellframe: 'CELL',
  Veritaseum: 'VERI',
  'Chain Guardians': 'CGG',
  SparkPoint: 'SRK',
  Gifto: 'GTO',
  HAPI: 'HAPI',
  BOSAGORA: 'BOA',
  ASTA: 'ASTA',
  'Santiment Network Token': 'SAN',
  BitKan: 'KAN',
  'BUX Token': 'BUX',
  '1irstcoin': 'FST',
  Pacoca: 'PACOCA',
  Zano: 'ZANO',
  Validity: 'VAL',
  Navcoin: 'NAV',
  'Callisto Network': 'CLO',
  'Galatasaray Fan Token': 'GAL',
  AntiMatter: 'MATTER',
  USDK: 'USDK',
  Vesper: 'VSP',
  'Mirrored Microsoft': 'mMSFT',
  DXdao: 'DXD',
  'Mirrored Invesco QQQ Trust': 'mQQQ',
  ETHPad: 'ETHPAD',
  'AC Milan Fan Token': 'ACM',
  HyperCash: 'HC',
  Curate: 'XCUR',
  'UBIX.Network': 'UBX',
  'Measurable Data Token': 'MDT',
  'Mirrored Tesla': 'mTSLA',
  'Chrono.tech': 'TIME',
  DIGG: 'DIGG',
  'EOS Force': 'EOSC',
  Juggernaut: 'JGN',
  SOLVE: 'SOLVE',
  '#MetaHash': 'MHC',
  'Mirrored Netflix': 'mNFLX',
  MileVerse: 'MVC',
  'Mirrored iShares Silver Trust': 'mSLV',
  BTSE: 'BTSE',
  'Mirrored Amazon': 'mAMZN',
  'Mirrored Apple': 'mAAPL',
  'Monsta Infinite': 'MONI',
  Synthetify: 'SNY',
  VelasPad: 'VLXPAD',
  QASH: 'QASH',
  'Wirex Token': 'WXT',
  'Cocos-BCX': 'COCOS',
  'Mirrored United States Oil Fund': 'mUSO',
  Sentivate: 'SNTVT',
  Pendle: 'PENDLE',
  'EpiK Protocol': 'EPK',
  'Mirrored Twitter': 'mTWTR',
  Exeedme: 'XED',
  'MAP Protocol': 'MAP',
  'Huobi Pool Token': 'HPT',
  'Drep [new]': 'DREP',
  'Router Protocol': 'ROUTE',
  'Venus Reward Token': 'VRT',
  MixMarvel: 'MIX',
  'Xeno Token': 'XNO',
  Wabi: 'WABI',
  Pangolin: 'PNG',
  LikeCoin: 'LIKE',
  ZeroSwap: 'ZEE',
  BLOCKv: 'VEE',
  Binamon: 'BMON',
  DEAPcoin: 'DEP',
  'Waves Enterprise': 'WEST',
  ERC20: 'ERC20',
  Skycoin: 'SKY',
  'Oxbull.tech': 'OXB',
  'NEST Protocol': 'NEST',
  'Assemble Protocol': 'ASM',
  'Tokamak Network': 'TON',
  Signum: 'SIGNA',
  'The Midas Touch Gold': 'TMTG',
  'Morpheus Labs': 'MITX',
  Finxflo: 'FXF',
  Quiztok: 'QTCON',
  TokenClub: 'TCT',
  Wownero: 'WOW',
  'Mirrored Alibaba': 'mBABA',
  DeGate: 'DG',
  Unifty: 'NIF',
  Peercoin: 'PPC',
  Switcheo: 'SWTH',
  'Electra Protocol': 'XEP',
  Misbloc: 'MSB',
  Adshares: 'ADS',
  dForce: 'DF',
  FOAM: 'FOAM',
  Nafter: 'NAFT',
  PlatON: 'LAT',
  Neblio: 'NEBL',
  Nebulas: 'NAS',
  Lithium: 'LITH',
  'Infinity PAD': 'IPAD',
  Namecoin: 'NMC',
  'Bitcoin 2': 'BTC2',
  'Emirex Token': 'EMRX',
  Civilization: 'CIV',
  'Hermez Network': 'HEZ',
  Cryptocean: 'CRON',
  Govi: 'GOVI',
  Ondori: 'RSTR',
  'TNC Coin': 'TNC',
  'Darwinia Network': 'RING',
  ELYSIA: 'EL',
  SafeCoin: 'SAFE',
  Cardstack: 'CARD',
  GameCredits: 'GAME',
  'Smart MFG': 'MFG',
  'LABS Group': 'LABS',
  'Adora Token': 'ARA',
  'GoCrypto Token': 'GOC',
  'Mirrored iShares Gold Trust': 'mIAU',
  KCCPAD: 'KCCPAD',
  GYEN: 'GYEN',
  'Poolz Finance': 'POOLZ',
  'FREE Coin': 'FREE',
  'DeepBrain Chain': 'DBC',
  Obyte: 'GBYTE',
  APIX: 'APIX',
  'LBRY Credits': 'LBC',
  'Electric Vehicle Zone': 'EVZ',
  SALT: 'SALT',
  'Growth DeFi': 'GRO',
  'STEM CELL COIN': 'SCC',
  Polkamarkets: 'POLK',
  suterusu: 'SUTER',
  KickToken: 'KICK',
  Talken: 'TALK',
  'Circuits of Value': 'COVAL',
  Ambrosus: 'AMB',
  'Juventus Fan Token': 'JUV',
  Modefi: 'MOD',
  'Unicly CryptoPunks Collection': 'UPUNK',
  Nxt: 'NXT',
  'e-Money': 'NGM',
  Dexlab: 'DXL',
  'Project Pai': 'PAI',
  'Venus SXP': 'vSXP',
  'Shapeshift FOX Token': 'FOX',
  Stakenet: 'XSN',
  '0Chain': 'ZCN',
  Ignis: 'IGNIS',
  Stafi: 'FIS',
  CryptoZoon: 'ZOON',
  Monetha: 'MTH',
  Nash: 'NEX',
  AppCoins: 'APPC',
  'Mirrored ProShares VIX': 'mVIXY',
  InsurAce: 'INSUR',
  'Konomi Network': 'KONO',
  'dHedge DAO': 'DHT',
  GAMB: 'GMB',
  'Litecoin Cash': 'LCC',
  DuckDaoDime: 'DDIM',
  TEMCO: 'TEMCO',
  'Bridge Mutual': 'BMI',
  Decentr: 'DEC',
  SIX: 'SIX',
  'MILC Platform': 'MLT',
  'Nucleus Vision': 'NCASH',
  'Empty Set Dollar': 'ESD',
  'BitZ Token': 'BZ',
  BetU: 'BETU',
  'YF Link': 'YFL',
  'BigONE Token': 'ONE',
  'My Master War': 'MAT',
  PRIZM: 'PZM',
  'King DAG': 'KDAG',
  'Deri Protocol': 'DERI',
  Lambda: 'LAMB',
  UniLayer: 'LAYER',
  'Atomic Wallet Coin': 'AWC',
  'Restart Energy MWAT': 'MWAT',
  '88mph': 'MPH',
  Swingby: 'SWINGBY',
  BaaSid: 'BAAS',
  BIDR: 'BIDR',
  Attila: 'ATT',
  'AS Roma Fan Token': 'ASR',
  'Idavoll Network': 'IDV',
  'Oraichain Token': 'ORAI',
  OAX: 'OAX',
  'Quantum Resistant Ledger': 'QRL',
  'Metaverse ETP': 'ETP',
  'Fenerbahçe Token': 'FB',
  Enecuum: 'ENQ',
  GamerCoin: 'GHX',
  GAMEE: 'GMEE',
  'Trias Token (new)': 'TRIAS',
  'Venus LINK': 'vLINK',
  Tarot: 'TAROT',
  Only1: 'LIKE',
  'Dora Factory': 'DORA',
  VIDY: 'VIDY',
  Aurora: 'AOA',
  'Dfyn Network': 'DFYN',
  'USDX [Lighthouse]': 'USDX',
  JulSwap: 'JULD',
  'DAFI Protocol': 'DAFI',
  Cashaa: 'CAS',
  'Plasma Finance': 'PPAY',
  Factom: 'FCT',
  'TE-FOOD': 'TONE',
  'Etherisc DIP Token': 'DIP',
  USDJ: 'USDJ',
  'Hiveterminal Token': 'HVN',
  DECOIN: 'DTEP',
  Dovu: 'DOV',
  'CyberFi Token': 'CFi',
  Arcblock: 'ABT',
  'CWV Chain': 'CWV',
  ArdCoin: 'ARDX',
  Bread: 'BRD',
  'Robonomics.network': 'XRT',
  Dentacoin: 'DCN',
  CYCLUB: 'CYCLUB',
  PolkaBridge: 'PBR',
  'Genesis Vision': 'GVT',
  'Pickle Finance': 'PICKLE',
  RioDeFi: 'RFUEL',
  'Venus LTC': 'vLTC',
  ICHI: 'ICHI',
  ROOBEE: 'ROOBEE',
  BoringDAO: 'BORING',
  ARMOR: 'ARMOR',
  'Minter Network': 'BIP',
  DinoSwap: 'DINO',
  EUNO: 'EUNO',
  Maple: 'MPL',
  'Galaxy Heroes Coin': 'GHC',
  'Seascape Crowns': 'CWS',
  Everex: 'EVX',
  'Moeda Loyalty Points': 'MDA',
  Observer: 'OBSR',
  MakiSwap: 'MAKI',
  CryptoBlades: 'SKILL',
  Hyve: 'HYVE',
  'Ronin Gamez': 'RONINGMZ',
  Graviton: 'GTON',
  DeHub: 'DEHUB',
  'ProBit Token': 'PROB',
  'Bone ShibaSwap': 'BONE',
  'Ripio Credit Network': 'RCN',
  'Niftyx Protocol': 'SHROOM',
  'BioPassport Token': 'BIOT',
  'Matrix AI Network': 'MAN',
  Crypterium: 'CRPT',
  Infinitecoin: 'IFC',
  Tokenomy: 'TEN',
  Peony: 'PNY',
  Binemon: 'BIN',
  Tixl: 'TXL',
  'Grid+': 'GRID',
  Oddz: 'ODDZ',
  TenX: 'PAY',
  'Tranche Finance': 'SLICE',
  UpBots: 'UBXT',
  'My DeFi Pet': 'DPET',
  Banano: 'BAN',
  PECULIUM: 'PCL',
  CyberVein: 'CVT',
  EasyFi: 'EZ',
  Agoras: 'AGRS',
  'Formation Fi': 'FORM',
  FLETA: 'FLETA',
  Sylo: 'SYLO',
  Ubiq: 'UBQ',
  BHPCoin: 'BHP',
  SolFarm: 'TULIP',
  PLATINCOIN: 'PLC',
  'PieDAO DOUGH v2': 'DOUGH',
  'Wall Street Games': 'WSG',
  Equalizer: 'EQZ',
  'Venus DOT': 'vDOT',
  'ExNetwork Token': 'EXNT',
  XMON: 'XMON',
  'Lightning Bitcoin': 'LBTC',
  BnkToTheFuture: 'BFT',
  Caspian: 'CSP',
  YOYOW: 'YOYOW',
  PolySwarm: 'NCT',
  'Safe Haven': 'SHA',
  BiFi: 'BIFI',
  'Epic Cash': 'EPIC',
  'NAOS Finance': 'NAOS',
  'Insights Network': 'INSTAR',
  Prosper: 'PROS',
  'apM Coin': 'APM',
  'Blank Wallet': 'BLANK',
  'Bonded Finance': 'BOND',
  'Metrix Coin': 'MRX',
  TrueChain: 'TRUE',
  Xaya: 'CHI',
  CONTRACOIN: 'CTCN',
  'Meter Governance': 'MTRG',
  TurtleCoin: 'TRTL',
  'BitForex Token': 'BF',
  'Degenerator Meme': 'MEME',
  'Cobak Token': 'CBK',
  'AXIS Token': 'AXIS',
  Einsteinium: 'EMC2',
  Viberate: 'VIB',
  K21: 'K21',
  'mStable Governance Token: Meta (MTA)': 'MTA',
  Olyseum: 'OLY',
  UniCrypt: 'UNCX',
  smARTOFGIVING: 'AOG',
  Kryll: 'KRL',
  'All Sports': 'SOC',
  CoinPoker: 'CHP',
  ALLY: 'ALY',
  TOP: 'TOP',
  HyperDAO: 'HDAO',
  Saito: 'SAITO',
  LaunchZone: 'LZ',
  'OIN Finance': 'OIN',
  'Duck DAO (DLP Duck Token)': 'DUCK',
  Diamond: 'DMD',
  'Float Protocol': 'BANK',
  'Step Hero': 'HERO',
  'Receive Access Ecosystem': 'RAE',
  Sakura: 'SKU',
  Gameswap: 'GSWAP',
  'Helmet.insure': 'HELMET',
  UREEQA: 'URQA',
  Mysterium: 'MYST',
  Bithao: 'BHAO',
  POA: 'POA',
  Signata: 'SATA',
  Anchor: 'ANCT',
  Quark: 'QRK',
  SpaceChain: 'SPC',
  LiquidApps: 'DAPP',
  'Era Swap': 'ES',
  OneLedger: 'OLT',
  'Time New Bank': 'TNB',
  'Bao Finance': 'BAO',
  'Linker Coin': 'LNC',
  'Nerve Finance': 'NRV',
  Lossless: 'LSS',
  HoDooi: 'HOD',
  'Anchor Neural World': 'ANW',
  'OG Fan Token': 'OG',
  DeFiner: 'FIN',
  Idle: 'IDLE',
  StakeCubeCoin: 'SCC',
  Blocknet: 'BLOCK',
  'UFC Fan Token': 'UFC',
  TrueFeedBack: 'TFBX',
  TrustVerse: 'TRV',
  Zap: 'ZAP',
  'Graphlinq Protocol': 'GLQ',
  'Alpha Impact': 'IMPACT',
  Agrello: 'DLT',
  'High Performance Blockchain': 'HPB',
  Pillar: 'PLR',
  BlockBank: 'BBANK',
  TOWER: 'TOWER',
  Opium: 'OPIUM',
  HEROcoin: 'PLAY',
  'X World Games': 'XWG',
  MoonSwap: 'MSWAP',
  'DEXA COIN': 'DEXA',
  Mobius: 'MOBI',
  Blocery: 'BLY',
  IQeon: 'IQN',
  'Origin Dollar': 'OUSD',
  AnimalGo: 'GOM2',
  Levolution: 'LEVL',
  Credits: 'CS',
  Swerve: 'SWRV',
  S4FE: 'S4F',
  'Hydro Protocol': 'HOT',
  Burency: 'BUY',
  'Metaverse Dualchain Network Architecture': 'DNA',
  AMLT: 'AMLT',
  TronEuropeRewardCoin: 'TERC',
  LuaSwap: 'LUA',
  SENSO: 'SENSO',
  Gulden: 'NLG',
  CONUN: 'CON',
  Bunicorn: 'BUNI',
  'SafeMoon Inu': 'SMI',
  Lamden: 'TAU',
  TenUp: 'TUP',
  'Tachyon Protocol': 'IPX',
  'Project WITH': 'WIKEN',
  Plian: 'PI',
  'Razor Network': 'RAZOR',
  StackOs: 'STACK',
  Cloudbric: 'CLBK',
  Hord: 'HORD',
  Offshift: 'XFT',
  Kalata: 'KALA',
  'Swarm Markets': 'SMT',
  NerveNetwork: 'NVT',
  Autonio: 'NIOX',
  'Safex Token': 'SFT',
  'RING X PLATFORM': 'RINGX',
  Nestree: 'EGG',
  Newton: 'NEW',
  Monolith: 'TKN',
  Zigcoin: 'ZIG',
  SaTT: 'SATT',
  'Standard Protocol': 'STND',
  APYSwap: 'APYS',
  ReapChain: 'REAP',
  BitcoinHD: 'BHD',
  SmartCash: 'SMART',
  'Realio Network': 'RIO',
  Kambria: 'KAT',
  'Trabzonspor Fan Token': 'TRA',
  'Don-key': 'DON',
  'CEEK VR': 'CEEK',
  FortKnoxster: 'FKX',
  'CBC.network': 'CBC',
  Covesting: 'COV',
  Refinable: 'FINE',
  Vidya: 'VIDYA',
  Opacity: 'OPCT',
  Kattana: 'KTN',
  Egretia: 'EGT',
  Wagerr: 'WGR',
  Howdoo: 'UDOO',
  Geeq: 'GEEQ',
  Lympo: 'LYM',
  Achain: 'ACT',
  Rotharium: 'RTH',
  'Valor Token': 'VALOR',
  'Cyclone Protocol': 'CYC',
  'ZBG Token': 'ZT',
  carVertical: 'CV',
  'QLC Chain': 'QLC',
  INT: 'INT',
  'ClinTex CTi': 'CTI',
  STARSHIP: 'STARSHIP',
  Airbloc: 'ABL',
  'Impossible Finance': 'IF',
  'Davinci Coin': 'DAC',
  'Rupiah Token': 'IDRT',
  'Basid Coin': 'BASID',
  ColossusXT: 'COLX',
  Breezecoin: 'BRZE',
  Zynecoin: 'ZYN',
  'Vanilla Network': 'VNLA',
  Muse: 'MUSE',
  Earneo: 'RNO',
  Spiking: 'SPIKE',
  UnMarshal: 'MARSH',
  Ispolink: 'ISP',
  DigitalNote: 'XDN',
  Revomon: 'REVO',
  'Project TXA': 'TXA',
  'Horizon Protocol': 'HZN',
  Abyss: 'ABYSS',
  'BSC Station': 'BSCS',
  VestChain: 'VEST',
  'Raze Network': 'RAZE',
  'EXMO Coin': 'EXM',
  ACENT: 'ACE',
  'Kira Network': 'KEX',
  MahaDAO: 'MAHA',
  PolkaCover: 'CVR',
  Eminer: 'EM',
  'YAM V3': 'YAM',
  'Beyond Finance': 'BYN',
  'TRAVA.FINANCE': 'TRAVA',
  Fractal: 'FCL',
  'Treat DAO': 'TREAT',
  'AGA Token': 'AGA',
  ProximaX: 'XPX',
  ZooKeeper: 'ZOO',
  MediShares: 'MDS',
  Shadows: 'DOWS',
  Bondly: 'BONDLY',
  HTMLCOIN: 'HTML',
  'Bird.Money': 'BIRD',
  CyberMiles: 'CMT',
  'UniMex Network': 'UMX',
  'X-CASH': 'XCASH',
  YUMMY: 'YUMMY',
  'ChangeNOW Token': 'NOW',
  Hedget: 'HGET',
  'PRCY Coin': 'PRCY',
  Aeon: 'AEON',
  LOCGame: 'LOCG',
  HorusPay: 'HORUS',
  'AAX Token': 'AAB',
  Myriad: 'XMY',
  eBoost: 'EBST',
  Conceal: 'CCX',
  Fear: 'FEAR',
  'Bridge Oracle': 'BRG',
  Snowball: 'SNOB',
  UnlimitedIP: 'UIP',
  'UCA Coin': 'UCA',
  'Virtue Poker': 'VPP',
  'DeFi Yield Protocol': 'DYP',
  SHIBAVAX: 'SHIBX',
  'Unido EP': 'UDO',
  'Folgory Coin': 'FLG',
  'Bitcoin Private': 'BTCP',
  SwftCoin: 'SWFTC',
  Vexanium: 'VEX',
  'Monero Classic': 'XMC',
  WebDollar: 'WEBD',
  Idena: 'IDNA',
  NANJCOIN: 'NANJ',
  'Lith Token': 'LITH',
  Cryptopay: 'CPAY',
  'Spores Network': 'SPO',
  Databroker: 'DTX',
  Trittium: 'TRTT',
  Dynamic: 'DYN',
  'Venus DAI': 'vDAI',
  EvidenZ: 'BCDT',
  PumaPay: 'PMA',
  THEKEY: 'TKY',
  Viacoin: 'VIA',
  'Raven Protocol': 'RAVEN',
  BOLT: 'BOLT',
  'Orient Walt': 'HTDF',
  'Global Coin Research': 'GCR',
  'Corra.Finance': 'CORA',
  Vabble: 'VAB',
  TriumphX: 'TRIX',
  'Hakka.Finance': 'HAKKA',
  Origo: 'OGO',
  Odyssey: 'OCN',
  'QuickX Protocol': 'QCX',
  ScPrime: 'SCP',
  'Smaugs NFT': 'SMG',
  Ghost: 'GHOST',
  OctoFi: 'OCTO',
  Chainge: 'CHNG',
  'Blockzero Labs': 'XIO',
  Moontography: 'MTGY',
  LCMS: 'LCMS',
  'Jade Currency': 'JADE',
  'Pundi X NEM': 'NPXSXEM',
  'IoT Chain': 'ITC',
  YUSRA: 'YUSRA',
  'Apron Network': 'APN',
  Argon: 'ARGON',
  LinkEye: 'LET',
  Feathercoin: 'FTC',
  'Xend Finance': 'XEND',
  'Bitcoin Atom': 'BCA',
  'Leverj Gluon': 'L2',
  Lanceria: 'LANC',
  Whiteheart: 'WHITE',
  'Unicly Hashmasks Collection': 'UMASK',
  Pallapay: 'PALLA',
  'Effect Network': 'EFX',
  Carboncoin: 'CARBON',
  SnowSwap: 'SNOW',
  BitcoinZ: 'BTCZ',
  'Innovation Blockchain Payment': 'IBP',
  'AnRKey X': '$ANRX',
  SakeToken: 'SAKE',
  'PowerTrade Fuel': 'PTF',
  Crowny: 'CRWNY',
  Centaur: 'CNTR',
  'DOC.COM': 'MTC',
  EXRNchain: 'EXRN',
  Qitmeer: 'PMEER',
  DeepOnion: 'ONION',
  Fatcoin: 'FAT',
  'Lympo Market Token': 'LMT',
  Verso: 'VSO',
  'SIRIN LABS Token': 'SRN',
  Elamachain: 'ELAMA',
  'Unicly Mystic Axies Collection': 'UAXIE',
  'Nord Finance': 'NORD',
  'Blizzard Network': 'BLIZZ',
  Jobchain: 'JOB',
  'Etho Protocol': 'ETHO',
  HitChain: 'HIT',
  bitCNY: 'BITCNY',
  Gridcoin: 'GRC',
  Onooks: 'OOKS',
  Zloadr: 'ZDR',
  '42-coin': '42',
  'DiFy.Finance': 'YFIII',
  pEOS: 'PEOS',
  VeriDocGlobal: 'VDG',
  Birake: 'BIR',
  Mist: 'MIST',
  'CACHE Gold': 'CGT',
  'IG Gold': 'IGG',
  TERA: 'TERA',
  Faceter: 'FACE',
  'Fuse Network': 'FUSE',
  hybrix: 'HY',
  Auctus: 'AUC',
  'Bibox Token': 'BIX',
  Primecoin: 'XPM',
  Ycash: 'YEC',
  Aventus: 'AVT',
  'Mobilian Coin': 'MBN',
  Nyzo: 'NYZO',
  Golff: 'GOF',
  '1World': '1WO',
  Unistake: 'UNISTAKE',
  'Name Change Token': 'NCT',
  Taraxa: 'TARA',
  Kalmar: 'KALM',
  MASQ: 'MASQ',
  Krios: 'GIG',
  REPO: 'REPO',
  'Redpanda Earth': 'REDPANDA',
  Coldstack: 'CLS',
  ILCOIN: 'ILC',
  'Props Token': 'PROPS',
  WePower: 'WPR',
  'Big Data Protocol': 'BDP',
  'Public Mint': 'MINT',
  Ruff: 'RUFF',
  Pluton: 'PLU',
  Rune: 'RUNE',
  Zenfuse: 'ZEFU',
  BOOM: 'BOOM',
  KuboCoin: 'KUBO',
  Eauric: 'EAURIC',
  'Endor Protocol': 'EDR',
  NuBits: 'USNBT',
  TransferCoin: 'TX',
  NFT: 'NFT',
  'CafeSwap Token': 'BREW',
  Insureum: 'ISR',
  'Step Finance': 'STEP',
  DePay: 'DEPAY',
  Footballcoin: 'XFC',
  'Mogul Productions': 'STARS',
  Graviocoin: 'GIO',
  ThreeFold: 'TFT',
  BlackCoin: 'BLK',
  'Public Index Network': 'PIN',
  Wings: 'WINGS',
  'Tidal Finance': 'TIDAL',
  'Dev Protocol': 'DEV',
  SunContract: 'SNC',
  Spore: 'SPORE',
  Garlicoin: 'GRLC',
  'Spheroid Universe': 'SPH',
  'OceanEx Token': 'OCE',
  ROCKI: 'ROCKI',
  Swarm: 'BZZ',
  WagyuSwap: 'WAG',
  'Advanced Technology Coin': 'ARC',
  'DOS Network': 'DOS',
  'Benchmark Protocol': 'MARK',
  Portion: 'PRT',
  Bitspawn: 'SPWN',
  'Digix Gold Token': 'DGX',
  TopBidder: 'BID',
  xSigma: 'SIG',
  MurAll: 'PAINT',
  Cred: 'LBA',
  yAxis: 'YAXIS',
  Carbon: 'CRBN',
  Monavale: 'MONA',
  TrueFlip: 'TFL',
  Xfinance: 'XFI',
  'Dracula Token': 'DRC',
  Lendingblock: 'LND',
  'Argentine Football Association Fan Token': 'ARG',
  AMEPAY: 'AME',
  'Gem Exchange And Trading': 'GXT',
  'Gravity Finance': 'GFI',
  'Stream Protocol': 'STPL',
  'U Network': 'UUU',
  AXPR: 'AXPR',
  SmartMesh: 'SMT',
  ASKO: 'ASKO',
  OTOCASH: 'OTO',
  'Ares Protocol': 'ARES',
  RealTract: 'RET',
  'SYNC Network': 'SYNC',
  NaPoleonX: 'NPX',
  'Rocket Vault-RocketX': 'RVF',
  Unitrade: 'TRADE',
  Gleec: 'GLEEC',
  DATA: 'DTA',
  Tokes: 'TKS',
  DAEX: 'DAX',
  Shard: 'SHARD',
  'eXPerience Chain': 'XPC',
  CloakCoin: 'CLOAK',
  Kcash: 'KCASH',
  PhoenixDAO: 'PHNX',
  Flixxo: 'FLIXX',
  'Rainbow Token': 'RAINBOW',
  Polker: 'PKR',
  Zoracles: 'ZORA',
  'Cook Protocol': 'COOK',
  Fabric: 'FAB',
  'Genaro Network': 'GNX',
  BitCore: 'BTX',
  PotCoin: 'POT',
  Emercoin: 'EMC',
  Forefront: 'FF',
  Cryptaur: 'CPT',
  'Lead Wallet': 'LEAD',
  'UTU Protocol': 'UTU',
  VINchain: 'VIN',
  Kryptomon: 'KMON',
  Atmos: 'ATMOS',
  'MIR COIN': 'MIR',
  'Governor DAO': 'GDAO',
  'Pepemon Pepeballs': 'PPBLZ',
  DAOstack: 'GEN',
  XMax: 'XMX',
  'Inex Project': 'INEX',
  'Game.com': 'GTC',
  'World Token': 'WORLD',
  EthereumX: 'ETX',
  'Safex Cash': 'SFX',
  'Alfa Romeo Racing ORLEN Fan Token': 'SAUBER',
  PLANET: 'PLA',
  DragonVein: 'DVC',
  'Atlas Protocol': 'ATP',
  'Phantasma Energy': 'KCAL',
  SynchroBitcoin: 'SNB',
  'Aston Martin Cognizant Fan Token': 'AM',
  Ulord: 'UT',
  'Global Social Chain': 'GSC',
  'NFT Index': 'NFTI',
  FedoraCoin: 'TIPS',
  'SoMee.Social [OLD]': 'ONG',
  xSuter: 'XSUTER',
  'Ryo Currency': 'RYO',
  NextDAO: 'NAX',
  'Seele-N': 'SEELE',
  Tripio: 'TRIO',
  'Open Platform': 'OPEN',
  'Waifu Token': 'WAIF',
  'Education Ecosystem': 'LEDU',
  'Mint Club': 'MINT',
  Essentia: 'ESS',
  'Link Machine Learning': 'LML',
  STATERA: 'STA',
  Splyt: 'SHOPX',
  'Göztepe S.K. Fan Token': 'GOZ',
  Scala: 'XLA',
  'Loser Coin': 'LOWB',
  Ixcoin: 'IXC',
  Stealth: 'XST',
  'Yield Optimization Platform & Protocol': 'YOP',
  PlotX: 'PLOT',
  WOWswap: 'WOW',
  Litex: 'LXT',
  'Q DAO Governance token v1.0': 'QDAO',
  'TheForce Trade': 'FOC',
  Pinkcoin: 'PINK',
  Swace: 'SWACE',
  DEEPSPACE: 'DPS',
  Tokoin: 'TOKO',
  'YFDAI.FINANCE': 'YF-DAI',
  Aitra: 'AITRA',
  Vetri: 'VLD',
  yieldwatch: 'WATCH',
  'Neural Protocol': 'NRP',
  Denarius: 'D',
  BillionHappiness: 'BHC',
  HempCoin: 'THC',
  VAULT: 'VAULT',
  EDUCare: 'EKT',
  'Sint-Truidense Voetbalvereniging Fan Token': 'STV',
  'SAFE DEAL': 'SFD',
  Neurotoken: 'NTK',
  OST: 'OST',
  Arata: 'ARATA',
  FairGame: 'FAIR',
  'YOU COIN': 'YOU',
  EOSDT: 'EOSDT',
  'Indexed Finance': 'NDX',
  'Non-Fungible Yearn': 'NFY',
  Digitex: 'DGTX',
  'Citadel.one': 'XCT',
  '2crazyNFT': '2CRZ',
  '4THPILLAR TECHNOLOGIES': 'FOUR',
  'Centric Swap': 'CNS',
  Unvest: 'UNV',
  CPChain: 'CPC',
  'Darwinia Commitment Token': 'KTON',
  'Iconic Token': 'ICNQ',
  QuadrantProtocol: 'EQUAD',
  Blackmoon: 'BMC',
  GeoDB: 'GEO',
  τBitcoin: 'ΤBTC',
  'Depth Token': 'DEP',
  NFTLootBox: 'LOOT',
  'WinStars.live': 'WNL',
  Jupiter: 'JUP',
  'Insured Finance': 'INFI',
  HeroFi: 'HEROEGG',
  Ditto: 'DITTO',
  VIBE: 'VIBE',
  ODUWA: 'OWC',
  SEEN: 'SEEN',
  'Tadpole Finance': 'TAD',
  '0xBitcoin': '0xBTC',
  'Crust Shadow': 'CSM',
  'e-Gulden': 'EFL',
  '1X2 COIN': '1X2',
  OptionRoom: 'ROOM',
  'Signature Chain': 'SIGN',
  HiCoin: 'XHI',
  BIKI: 'BIKI',
  Mettalex: 'MTLX',
  Dimecoin: 'DIME',
  'Coin Artist': 'COIN',
  Bismuth: 'BIS',
  'Vipstar Coin': 'VIPS',
  'ADAMANT Messenger': 'ADM',
  Landshare: 'LAND',
  'SmartCredit Token': 'SMARTCREDIT',
  Xensor: 'XSR',
  SuperLauncher: 'LAUNCH',
  Dacxi: 'DACXI',
  'ODIN PROTOCOL': 'ODIN',
  'Ducato Protocol Token': 'DUCATO',
  Cryptonovae: 'YAE',
  Chainswap: 'ASAP',
  Sumokoin: 'SUMO',
  'Waves Community Token': 'WCT',
  'Pancake Bunny': 'BUNNY',
  'Zerogoki USD': 'zUSD',
  AICHAIN: 'AIT',
  Kineko: 'KKO',
  EarnX: 'EARNX',
  Phore: 'PHR',
  Polis: 'POLIS',
  'CHADS VC': 'CHADS',
  'Genesis Shards': 'GS',
  PolkaWar: 'PWAR',
  'Bean Cash': 'BITB',
  'Stake DAO': 'SDT',
  'Bitcoin Plus': 'XBC',
  'Doki Doki Finance': 'DOKI',
  'Falcon Project': 'FNT',
  Cappasity: 'CAPP',
  BLink: 'BLINK',
  'EOS TRUST': 'EOST',
  'DMM: Governance': 'DMG',
  Zero: 'ZER',
  'I/O Coin': 'IOC',
  Mochimo: 'MCM',
  Ideaology: 'IDEA',
  BOMB: 'BOMB',
  keyTango: 'TANGO',
  'Polyient Games Governance Token': 'PGT',
  'Wolf Safe Poor People': 'WSPP',
  PUBLISH: 'NEWS',
  CryptoFranc: 'XCHF',
  Peanut: 'NUX',
  Cornichon: 'CORN',
  'Global Cryptocurrency': 'GCC',
  FYDcoin: 'FYD',
  TradeStars: 'TSX',
  FujiCoin: 'FJC',
  'Aluna.Social': 'ALN',
  'BondAppétit Governance Token': 'BAG',
  'PWR Coin': 'PWR',
  Merculet: 'MVP',
  Iridium: 'IRD',
  ArGo: 'ARGO',
  CannabisCoin: 'CANN',
  SINOVATE: 'SIN',
  adbank: 'ADB',
  Honest: 'HNST',
  LINKA: 'LINKA',
  ContentBox: 'BOX',
  AGAr: 'AGAR',
  Kangal: 'KANGAL',
  Enigma: 'ENG',
  PlayFuel: 'PLF',
  'Netbox Coin': 'NBX',
  Curecoin: 'CURE',
  Unification: 'FUND',
  Trollcoin: 'TROLL',
  'Natus Vincere Fan Token': 'NAVI',
  OKCash: 'OK',
  TokenPay: 'TPAY',
  TurtleNetwork: 'TN',
  'Drops Ownership Power': 'DOP',
  Evedo: 'EVED',
  'B-cube.ai': 'BCUBE',
  'Titan Coin': 'TTN',
  Mcashchain: 'MCASH',
  Incent: 'INCNT',
  GHOSTPRISM: 'GHOST',
  'Kuai Token': 'KT',
  Playcent: 'PCNT',
  'Basis Cash': 'BAC',
  SureRemit: 'RMT',
  BlackHat: 'BLKC',
  VeriCoin: 'VRC',
  'Grumpy.finance': 'GRUMPY',
  'ETNA Network': 'ETNA',
  Falconswap: 'FSW',
  'PERI Finance': 'PERI',
  Medicalchain: 'MTN',
  'Young Boys Fan Token': 'YBO',
  RigoBlock: 'GRG',
  BiShares: 'BISON',
  'Venus BCH': 'vBCH',
  Multiplier: 'BMXX',
  AMATEN: 'AMA',
  Amon: 'AMN',
  SpectrumCash: 'XSM',
  Omni: 'OMNI',
  'Jarvis Network': 'JRT',
  Polytrade: 'TRADE',
  Filecash: 'FIC',
  Patron: 'PAT',
  disBalancer: 'DDOS',
  'Squirrel Finance': 'NUTS',
  'Blockchain Cuties Universe Governance': 'BCUG',
  FairCoin: 'FAIR',
  SHPING: 'SHPING',
  Polkalokr: 'LKR',
  Bitswift: 'BITS',
  'Ethereum Gold Project': 'ETGP',
  'Ravencoin Classic': 'RVC',
  'Machi X': 'MCX',
  MyWish: 'WISH',
  'Ethereum Meta': 'ETHM',
  BitTube: 'TUBE',
  'Sakura Bloom': 'SKB',
  iEthereum: 'IETH',
  'Skrumble Network': 'SKM',
  'W Green Pay': 'WGP',
  ZClassic: 'ZCL',
  Sharder: 'SS',
  DAOventures: 'DVD',
  Antiample: 'XAMP',
  'Decentralized Vulnerability Platform': 'DVP',
  Humaniq: 'HMQ',
  YEE: 'YEE',
  'Universidad de Chile Fan Token': 'UCH',
  Remme: 'REM',
  'Perth Mint Gold Token': 'PMGT',
  '2key.network': '2KEY',
  'Skyrim Finance': 'SKYRIM',
  Lobstex: 'LOBS',
  'X8X Token': 'X8X',
  PIXEL: 'PXL',
  Parachute: 'PAR',
  KanadeCoin: 'KNDC',
  'PANTHEON X': 'XPN',
  'Scry.info': 'DDD',
  Coreto: 'COR',
  Aryacoin: 'AYA',
  UGAS: 'UGAS',
  HaloDAO: 'RNBW',
  Plair: 'PLA',
  NeuroChain: 'NCC',
  'DFSocial Gaming': 'DFSOCIAL',
  CryptoTycoon: 'CTT',
  Veil: 'VEIL',
  AtromG8: 'AG8',
  ChatCoin: 'CHAT',
  AidCoin: 'AID',
  ZumCoin: 'ZUM',
  'Digital Reserve Currency': 'DRC',
  'Berry Data': 'BRY',
  'SparkPoint Fuel': 'SFUEL',
  'Isiklar Coin': 'ISIKC',
  'Relite Finance': 'RELI',
  'Node Runners': 'NDR',
  'Infinity Esaham': 'INFS',
  Ethverse: 'ETHV',
  'Phoenix Token': 'PHX',
  'Vox.Finance': 'VOX',
  Hydro: 'HYDRO',
  'GokuMarket Credit': 'GMC',
  ZUSD: 'ZUSD',
  'BOX Token': 'BOX',
  LocalCoinSwap: 'LCS',
  Famcentral: 'FAM',
  Thisoption: 'TONS',
  Phoenixcoin: 'PXC',
  Substratum: 'SUB',
  ParkinGo: 'GOT',
  'DAPS Coin': 'DAPS',
  Ceres: 'CERES',
  'AFEN Blockchain': 'AFEN',
  'MintMe.com Coin': 'MINTME',
  Patientory: 'PTOY',
  BitBall: 'BTB',
  MonetaryUnit: 'MUE',
  Katalyo: 'KTLYO',
  'PieDAO DEFI++': 'DEFI++',
  'Defis Network': 'DFS',
  DinoExchange: 'DINO',
  ESBC: 'ESBC',
  'Dragon Coins': 'DRG',
  Karbo: 'KRB',
  Furucombo: 'COMBO',
  'Professional Fighters League Fan Token': 'PFL',
  'SolanaSail Governance Token': 'GSAIL',
  Crown: 'CRW',
  Hashgard: 'GARD',
  'Silver Stonks': 'SSTX',
  'ETHA Lend': 'ETHA',
  'Tidex Token': 'TDX',
  Fera: 'FERA',
  CryptEx: 'CRX',
  Pigeoncoin: 'PGN',
  'Pivot Token': 'PVT',
  Nexalt: 'XLT',
  'Unicly Aavegotchi Astronauts Collection': 'UGOTCHI',
  LanaCoin: 'LANA',
  'Heart Number': 'HTN',
  StakedZEN: 'STZEN',
  MobileGo: 'MGO',
  Chonk: 'CHONK',
  Xaurum: 'XAUR',
  'Robust Token': 'RBT',
  'Origin Sport': 'ORS',
  BitcoinPoS: 'BPS',
  'Buying.com': 'WBUY',
  'Zebi Token': 'ZEBI',
  Upfiring: 'UFR',
  'Alliance Fan Token': 'ALL',
  'The ChampCoin': 'TCC',
  'Collateral Pay': 'COLL',
  Ubex: 'UBEX',
  "Bob's Repair": 'BOB',
  NIX: 'NIX',
  MoonTrust: 'MNTT',
  ZrCoin: 'ZRC',
  Delphy: 'DPY',
  TouchCon: 'TOC',
  HollyGold: 'HGOLD',
  'Bitcoin Confidential': 'BC',
  Lendefi: 'LDFI',
  Pawtocol: 'UPI',
  GeoCoin: 'GEO',
  Auxilium: 'AUX',
  'DAV Coin': 'DAV',
  'PEPS Coin': 'PEPS',
  Bitgear: 'GEAR',
  BeatzCoin: 'BTZC',
  'VNT Chain': 'VNT',
  'Yield Protocol': 'YIELD',
  MetaMorph: 'METM',
  BonusCloud: 'BXC',
  Cajutel: 'CAJ',
  LUXCoin: 'LUX',
  'Naka Bodhi Token': 'NBOT',
  'NFTX Hashmasks Index': 'MASK',
  'Alphr finance': 'ALPHR',
  Moneytoken: 'IMT',
  StakerDAO: 'STKR',
  Oikos: 'OKS',
  ByteNext: 'BNU',
  Internxt: 'INXT',
  OLXA: 'OLXA',
  Beacon: 'BECN',
  WeOwn: 'CHX',
  Tapmydata: 'TAP',
  ION: 'ION',
  'Catex Token': 'CATT',
  HEAT: 'HEAT',
  LunchMoney: 'LMY',
  eosDAC: 'EOSDAC',
  $LONDON: 'LONDON',
  'Shield Protocol': 'SHIELD',
  HOMIHELP: 'HOMI',
  Beaxy: 'BXY',
  BUZZCoin: 'BUZZ',
  Starbase: 'STAR',
  'Wrapped Gen-0 CryptoKitties': 'WG0',
  Pizza: 'PIZZA',
  AudioCoin: 'ADC',
  'Jarvis+': 'JAR',
  'Rage Fan': 'RAGE',
  'Mochi Market': 'MOMA',
  QChi: 'QCH',
  'Memetic / PepeCoin': 'MEME',
  Nuggets: 'NUG',
  'Indorse Token': 'IND',
  'Coinsbit Token': 'CNB',
  SonoCoin: 'SONO',
  'PHI Token': 'PHI',
  Streamity: 'STM',
  'XcelToken Plus': 'XLAB',
  Subme: 'SUB',
  Bezant: 'BZNT',
  'Nsure.Network': 'NSURE',
  'reflect.finance': 'RFI',
  'Pylon Finance': 'PYLON',
  Maxcoin: 'MAX',
  DexKit: 'KIT',
  Expanse: 'EXP',
  JustBet: 'WINR',
  'SONM (BEP-20)': 'SNM',
  Posscoin: 'POSS',
  'BitScreener Token': 'BITX',
  FlypMe: 'FYP',
  Banca: 'BANCA',
  'Primalbase Token': 'PBT',
  PetroDollar: 'XPD',
  Maincoin: 'MNC',
  Pascal: 'PASC',
  'yTSLA Finance': 'yTSLA',
  DATx: 'DATX',
  DMarket: 'DMT',
  'FintruX Network': 'FTX',
  BonFi: 'BNF',
  Tolar: 'TOL',
  BitCapitalVendor: 'BCV',
  'Club Atletico Independiente': 'CAI',
  GoWithMi: 'GMAT',
  NativeCoin: 'N8V',
  'Legia Warsaw Fan Token': 'LEG',
  TotemFi: 'TOTM',
  'Kwikswap Protocol': 'KWIK',
  '8X8 PROTOCOL': 'EXE',
  'Yellow Road': 'ROAD',
  Lepricon: 'L3P',
  'Open Governance Token': 'OPEN',
  TENT: 'TENT',
  'Digital Insurance Token': 'DIT',
  'Hertz Network': 'HTZ',
  'Blue Whale EXchange': 'BWX',
  OWNDATA: 'OWN',
  DDKoin: 'DDK',
  'SOTA Finance': 'SOTA',
  xRhodium: 'XRC',
  Primas: 'PST',
  UniFarm: 'UFARM',
  Donut: 'DONUT',
  BitDegree: 'BDG',
  DeHive: 'DHV',
  Lightstreams: 'PHT',
  Masari: 'MSR',
  PayPie: 'PPP',
  'Meeb Master': 'MEEB',
  CoTrader: 'COT',
  Vid: 'VI',
  TrumpCoin: 'TRUMP',
  Azuki: 'AZUKI',
  MenaPay: 'MPAY',
  Penta: 'PNT',
  AstroTools: 'ASTRO',
  KIWIGO: 'KGO',
  Fyooz: 'FYZ',
  VIG: 'VIG',
  MicroBitcoin: 'MBC',
  Smoothy: 'SMTY',
  Font: 'FONT',
  'Golos Blockchain': 'GLS',
  Hush: 'HUSH',
  'Content Neutrality Network': 'CNN',
  Lethean: 'LTHN',
  Polinate: 'POLI',
  KamPay: 'KAMPAY',
  'Apollon Limassol': 'APL',
  REVIVAL: 'RVL',
  'İstanbul Başakşehir Fan Token': 'IBFK',
  Omnitude: 'ECOM',
  Motocoin: 'MOTO',
  Snetwork: 'SNET',
  'Add.xyz': 'ADD',
  DomRaider: 'DRT',
  ExclusiveCoin: 'EXCL',
  'Base Protocol': 'BASE',
  Bitstar: 'BITS',
  KeyFi: 'KEYFI',
  MoonTools: 'MOONS',
  Fountain: 'FTN',
  ZENZO: 'ZNZ',
  'Royale Finance': 'ROYA',
  bAlpha: 'BALPHA',
  'Typhoon Network': 'TYPH',
  IXT: 'IXT',
  Orbitcoin: 'ORB',
  'Bitcoin Green': 'BITG',
  Nerva: 'XNV',
  'Secure Pad': 'SEPA',
  Xiotri: 'XIOT',
  BarterTrade: 'BART',
  '2gather': 'TWO',
  iDealCash: 'DEAL',
  OracleChain: 'OCT',
  'Acute Angle Cloud': 'AAC',
  '0xcert': 'ZXC',
  'ORAO Network': 'ORAO',
  CryptoTask: 'CTASK',
  'GlobalBoost-Y': 'BSTY',
  Paybswap: 'PAYB',
  Playkey: 'PKT',
  BlitzPick: 'XBP',
  POLKARARE: 'PRARE',
  SophiaTX: 'SPHTX',
  Minereum: 'MNE',
  Stipend: 'SPD',
  'GamyFi Platform': 'GFX',
  Azbit: 'AZ',
  Datum: 'DAT',
  Crypton: 'CRP',
  'Goose Finance': 'EGG',
  Etherparty: 'FUEL',
  'Warp Finance': 'WARP',
  NuShares: 'NSR',
  Actinium: 'ACM',
  PolkaDomain: 'NAME',
  'MAX Exchange Token': 'MAX',
  GoldenPyrex: 'GPYX',
  VikkyToken: 'VIKKY',
  'Team Vitality Fan Token': 'VIT',
  NEXT: 'NEXT',
  NFTify: 'N1',
  'Cat Token': 'CAT',
  Fluity: 'FLTY',
  '2local': '2LC',
  Qwertycoin: 'QWC',
  Ownly: 'OWN',
  MotaCoin: 'MOTA',
  'Electrify.Asia': 'ELEC',
  PirateCash: 'PIRATE',
  HOQU: 'HQX',
  SmileyCoin: 'SMLY',
  'Limitless VIP': 'VIP',
  'VegaWallet Token': 'VGW',
  Bottos: 'BTO',
  Tap: 'XTP',
  'Team Heretics Fan Token': 'TH',
  DOGEFI: 'DOGEFI',
  DPRating: 'RATING',
  Manna: 'MANNA',
  'Scorum Coins': 'SCR',
  QUINADS: 'QUIN',
  'Libertas Token': 'LIBERTAS',
  PiplCoin: 'PIPL',
  'SOAR.FI': 'SOAR',
  Freicoin: 'FRC',
  IntelliShare: 'INE',
  'OneRoot Network': 'RNT',
  REAL: 'REAL',
  FansTime: 'FTI',
  TigerCash: 'TCH',
  HYCON: 'HYC',
  CryptoBonusMiles: 'CBM',
  BITTO: 'BITTO',
  '1Million Token': '1MT',
  Edgeless: 'EDG',
  Matryx: 'MTX',
  MONK: 'MONK',
  FLIP: 'FLP',
  'Power Index Pool Token': 'PIPT',
  'Zero Utility Token': 'ZUT',
  Sharpay: 'S',
  'Ethereum Stake': 'ETHYS',
  CREA: 'CREA',
  'IHT Real Estate Protocol': 'IHT',
  Arqma: 'ARQ',
  Sether: 'SETH',
  Insula: 'ISLA',
  Woodcoin: 'LOG',
  DoYourTip: 'DYT',
  'LYNC Network': 'LYNC',
  'Eureka Coin': 'ERK',
  Rise: 'RISE',
  renDOGE: 'RENDOGE',
  GoByte: 'GBX',
  UpToken: 'UP',
  Kuende: 'KUE',
  CryptoSoul: 'SOUL',
  'Seigniorage Shares': 'SHARE',
  ACoconut: 'AC',
  uPlexa: 'UPX',
  'AI Doctor': 'AIDOC',
  Jetcoin: 'JET',
  Earnbase: 'ENB',
  Friendz: 'FDZ',
  Themis: 'MIS',
  'Spaceswap MILK2': 'MILK2',
  StrongHands: 'SHND',
  Teloscoin: 'TELOS',
  'Golden Goose': 'GOLD',
  Typerium: 'TYPE',
  'MODEL-X-coin': 'MODX',
  'TON Token': 'TON',
  Smartshare: 'SSP',
  Zennies: 'ZENI',
  'MEET.ONE': 'MEETONE',
  WeTrust: 'TRST',
  TOKPIE: 'TKP',
  extraDNA: 'XDNA',
  SIBCoin: 'SIB',
  ChessCoin: 'CHESS',
  SPINDLE: 'SPD',
  'Wolves of Wall Street': 'WOWS',
  Eternity: 'ENT',
  PutinCoin: 'PUT',
  'Save Environment Token': 'SET',
  'Ink Protocol': 'XNK',
  'Ethereum Yield': 'ETHY',
  'Axis DeFi': 'AXIS',
  Rate3: 'RTE',
  'Modern Investment Coin': 'MODIC',
  Mate: 'MATE',
  Phoneum: 'PHT',
  Terracoin: 'TRC',
  Curio: 'CUR',
  Moneynet: 'MNC',
  CoinFi: 'COFI',
  Debitum: 'DEB',
  ATLANT: 'ATL',
  Pakcoin: 'PAK',
  'Gourmet Galaxy': 'GUM',
  'CoinDeal Token': 'CDL',
  Kobocoin: 'KOBO',
  'Wrapped Basic CryptoKitties': 'WCK',
  'KIMCHI.finance': 'KIMCHI',
  'x42 Protocol': 'X42',
  'Blue Protocol': 'BLUE',
  PlayGame: 'PXG',
  'Decentralized Machine Learning': 'DML',
  STK: 'STK',
  'Spaceswap SHAKE': 'SHAKE',
  'Swarm City': 'SWT',
  RED: 'RED',
  Rublix: 'RBLX',
  CustomContractNetwork: 'CCN',
  'Po.et': 'POE',
  Alphacat: 'ACAT',
  Equal: 'EQL',
  EtherGem: 'EGEM',
  'CheesecakeSwap Token': 'CCAKE',
  DecentBet: 'DBET',
  XTRABYTES: 'XBY',
  '8PAY': '8PAY',
  'Alt.Estate token': 'ALT',
  ShipChain: 'SHIP',
  EventChain: 'EVC',
  Keep4r: 'KP4R',
  Qbao: 'QBT',
  'Bobo Cash': 'BOBO',
  SafeBlast: 'BLAST',
  Startcoin: 'START',
  TrezarCoin: 'TZC',
  'Ormeus Ecosystem': 'ECO',
  Sessia: 'KICKS',
  Birdchain: 'BIRD',
  COVA: 'COVA',
  'Nuco.cloud': 'NCDT',
  'DeFi Bids': 'BID',
  Zeepin: 'ZPT',
  'Shadow Token': 'SHDW',
  DACSEE: 'DACS',
  'NeoWorld Cash': 'NASH',
  AquariusCoin: 'ARCO',
  'Sportcash One': 'SCONEX',
  Swap: 'XWP',
  Synergy: 'SNRG',
  'Project Inverse': 'XIV',
  'Crypto Sports': 'CSPN',
  Bezop: 'BEZ',
  DogeCash: 'DOGEC',
  Digitalcoin: 'DGC',
  EchoLink: 'EKO',
  'CUE Protocol': 'CUE',
  Netko: 'NETKO',
  Cryptonite: 'XCN',
  Kommunitas: 'KOM',
  'ZUM TOKEN': 'ZUM',
  DopeCoin: 'DOPE',
  BabyUSDT: 'BABYUSDT',
  Zetacoin: 'ZET',
  Hyperion: 'HYN',
  Rapidz: 'RPZX',
  ChartEx: 'CHART',
  ETHERLAND: 'ELAND',
  'Trinity Network Credit': 'TNC',
  Fundamenta: 'FMTA',
  Tornado: 'TCORE',
  MMOCoin: 'MMO',
  'Gems ': 'GEM',
  xBTC: 'xBTC',
  HashCoin: 'HSC',
  RMPL: 'RMPL',
  Swing: 'SWING',
  Datamine: 'DAM',
  'Kingdom Game 4.0': 'KDG',
  Ritocoin: 'RITO',
  GoldMint: 'MNTP',
  Dether: 'DTH',
  'Method Finance': 'MTHD',
  Stox: 'STX',
  'Novara Calcio Fan Token': 'NOV',
  'MU DANK': 'DANK',
  DEJAVE: 'DJV',
  BiblePay: 'BBP',
  AllSafe: 'ASAFE',
  Dogeswap: 'DOGES',
  'Spectre.ai Utility Token': 'SXUT',
  Lition: 'LIT',
  ZelaaPayAE: 'ZPAE',
  ChronoBase: 'TIK',
  'Color Platform': 'CLR',
  'Sora Validator Token': 'VAL',
  'Blockmason Credit Protocol': 'BCPT',
  'KoHo Chain': 'KHC',
  'The Corgi of PolkaBridge': 'CORGIB',
  Ubricoin: 'UBN',
  'Alpha Token': 'A',
  'MIB Coin': 'MIB',
  Tokenbox: 'TBX',
  HashBX: 'HBX',
  Arbidex: 'ABX',
  MesChain: 'MES',
  'EveryCoin ': 'EVY',
  'Felixo Coin': 'FLX',
  Bounty0x: 'BNTY',
  Tendies: 'TEND',
  Polar: 'POLARV3',
  Ink: 'INK',
  Playgroundz: 'IOG',
  BlueCoin: 'BLU',
  Graft: 'GRFT',
  'Rigel Protocol': 'RGP',
  DMScript: 'DMST',
  'Fortuna Sittard Fan Token': 'FOR',
  Bitether: 'BTR',
  'Xion Finance': 'XGT',
  'Beer Money': 'BEER',
  Ignition: 'IC',
  'Ethereum Gold': 'ETG',
  'YVS.Finance': 'YVS',
  Blockburn: 'BURN',
  TagCoin: 'TAG',
  Savix: 'SVX',
  Membrana: 'MBN',
  Asch: 'XAS',
  MidasProtocol: 'MAS',
  'EDC Blockchain': 'EDC',
  FuzeX: 'FXT',
  'Niobium Coin': 'NBC',
  'Yap Stone': 'YAP',
  'Bitcoin Interest': 'BCI',
  'Escroco Emerald': 'ESCE',
  Bitzeny: 'ZNY',
  'PoSW Coin': 'POSW',
  'Clash Token': 'SCT',
  TrueDeck: 'TDP',
  '2GIVE': '2GIVE',
  'Decentralized Crypto Token': 'DCTO',
  BoutsPro: 'BOUTS',
  Yocoin: 'YOC',
  Megacoin: 'MEC',
  'Chi Gastoken': 'CHI',
  MyBit: 'MYB',
  Rope: '$ROPE',
  'Wrapped Virgin Gen-0 CryptoKitties': 'WVG0',
  'PYRO Network': 'PYRO',
  Parkgene: 'GENE',
  'KnoxFS (new)': 'KFX',
  Precium: 'PCM',
  HelloGold: 'HGT',
  Rivetz: 'RVT',
  GoNetwork: 'GOT',
  'Block-Logic': 'BLTG',
  IONChain: 'IONC',
  'Unicly Doki Doki Collection': 'UDOKI',
  Kuverit: 'KUV',
  PDATA: 'PDATA',
  Interlude: 'ISH',
  'ICE ROCK MINING': 'ROCK2',
  Elysian: 'ELY',
  'Stobox Token': 'STBU',
  BSCView: 'BSCV',
  Rentberry: 'BERRY',
  'FUD.finance': 'FUD',
  Vidulum: 'VDL',
  Blockpass: 'PASS',
  Widercoin: 'WDR',
  Zeusshield: 'ZSC',
  CryptoFlow: 'CFL',
  'Unicly Chris McCann Collection': 'UCM',
  ZPER: 'ZPR',
  'Master Contract Token': 'MCT',
  CROAT: 'CROAT',
  'BackPacker Coin': 'BPC',
  Bela: 'BELA',
  'Yearn Secure': 'YSEC',
  VouchForMe: 'IPL',
  Rapids: 'RPD',
  Devery: 'EVE',
  Fortuna: 'FOTA',
  Maecenas: 'ART',
  Helix: 'HLIX',
  'Renewable Electronic Energy Coin': 'REEC',
  Bitgesell: 'BGL',
  PengolinCoin: 'PGO',
  Stabilize: 'STBZ',
  'Crypto Kombat': 'KOMBAT',
  Cubiex: 'CBIX',
  'Ormeus Coin': 'ORMEUS',
  Scrypta: 'LYRA',
  ATN: 'ATN',
  InterValue: 'INVE',
  'Evil Coin': 'EVIL',
  Bancacy: 'BNY',
  Showcase: 'SHO',
  'Ether Zero': 'ETZ',
  'Sentinel Chain': 'SENC',
  Cobinhood: 'COB',
  MicroMoney: 'AMM',
  'ATC Coin': 'ATCC',
  Opal: 'OPAL',
  CorionX: 'CORX',
  Collective: 'CO2',
  Cryptojacks: 'CJ',
  'PKG Token': 'PKG',
  'Innovative Bioresearch Coin': 'INNBC',
  SkinCoin: 'SKIN',
  'StrongHands Masternode': 'SHMN',
  'NFX Coin': 'NFXC',
  'Kind Ads Token': 'KIND',
  Cheesecoin: 'CHEESE',
  MORPHOSE: 'MORPH',
  Energo: 'TSL',
  Noir: 'NOR',
  'Cyber Movie Chain': 'CMCT',
  Rotten: 'ROT',
  Winco: 'WCO',
  'AiLink Token': 'ALI',
  TRAXIA: 'TM2',
  Lunyr: 'LUN',
  BZEdge: 'BZE',
  Eroscoin: 'ERO',
  Innova: 'INN',
  'UBU Finance': 'UBU',
  EtherInc: 'ETI',
  AceD: 'ACED',
  Opus: 'OPT',
  ModiHost: 'AIM',
  'NestEGG Coin': 'EGG',
  ZeuxCoin: 'ZUC',
  'Fire Lotto': 'FLOT',
  WABnetwork: 'WAB',
  BSClaunch: 'BSL',
  'Cosmo Coin': 'COSM',
  VNX: 'VNXLU',
  BidiPass: 'BDP',
  InsaneCoin: 'INSN',
  'Decentrahub Coin': 'DCNTR',
  Sociall: 'SCL',
  CashHand: 'CHND',
  PluraCoin: 'PLURA',
  'Emerald Crypto': 'EMD',
  Switch: 'ESH',
  'Meridian Network': 'LOCK',
  'Datamine FLUX': 'FLUX',
  Axe: 'AXE',
  Solaris: 'XLR',
  'Bridge Protocol': 'BRDG',
  Dynamite: 'DYNMT',
  GoldFund: 'GFUN',
  Matrexcoin: 'MAC',
  'Thrive Token': 'THRT',
  PRIA: 'PRIA',
  OptiToken: 'OPTI',
  Kurrent: 'KURT',
  SingularDTV: 'SNGLS',
  BitCash: 'BITC',
  ImageCoin: 'IMG',
  Bata: 'BTA',
  Chronologic: 'DAY',
  SwiftCash: 'SWIFT',
  Bitcloud: 'BTDX',
  SynLev: 'SYN',
  'IQ.cash': 'IQ',
  Polkally: 'KALLY',
  Zilla: 'ZLA',
  megaBONK: 'MBONK',
  PAYCENT: 'PYN',
  LHT: 'LHT',
  'Universal Currency': 'UNIT',
  'Bitcashpay (old)': 'BCP',
  'Bitcoin Token': 'BTCT',
  '1MillionNFTs': '1MIL',
  'More Coin': 'MORE',
  'Coinsuper Ecosystem Network': 'CEN',
  GlobalToken: 'GLT',
  Landbox: 'LAND',
  GoldBlocks: 'GB',
  'Beetle Coin': 'BEET',
  'Peseta Digital': 'PTD',
  Artfinity: 'AT',
  Bitblocks: 'BBK',
  'Deutsche eMark': 'DEM',
  HeartBout: 'HB',
  Transcodium: 'TNS',
  'FSBT API Token': 'FSBT',
  'Gene Source Code Chain': 'GENE',
  'Bitcoin Classic': 'BXC',
  Bigbom: 'BBO',
  SafeInsure: 'SINS',
  'Insight Protocol': 'INX',
  SHIELD: 'XSH',
  InvestDigital: 'IDT',
  ATBCoin: 'ATB',
  Truegame: 'TGAME',
  Fireball: 'FIRE',
  'NFT Alley': 'ALLEY',
  'Italian Lira': 'ITL',
  MojoCoin: 'MOJO',
  'BLOC.MONEY': 'BLOC',
  PayCoin: 'XPY',
  Nasdacoin: 'NSD',
  'Cubiex Power': 'CBIX-P',
  NevaCoin: 'NEVA',
  Connectome: 'CNTM',
  Cipher: 'CPR',
  'Fox Trading': 'FOXT',
  'Litecoin Plus': 'LCP',
  SmartCoin: 'SMC',
  imbrex: 'REX',
  Agora: 'VOTE',
  'Boosted Finance': 'BOOST',
  JUIICE: 'JUI',
  'FNB Protocol': 'FNB',
  Castweet: 'CTT',
  Gentarium: 'GTM',
  Aditus: 'ADI',
  TrustDAO: 'TRUST',
  Semux: 'SEM',
  Fesschain: 'FESS',
  Anoncoin: 'ANC',
  BitWhite: 'BTW',
  Twinci: 'TWIN',
  Fivebalance: 'FBN',
  'Open Predict Token': 'OPT',
  BBSCoin: 'BBS',
  'Webflix Token': 'WFX',
  Blocktix: 'TIX',
  Adzcoin: 'ADZ',
  LuckySevenToken: 'LST',
  'GCN Coin': 'GCN',
  SiaCashCoin: 'SCC',
  'srnArt Gallery': 'SACT',
  EvenCoin: 'EVN',
  InvestFeed: 'IFT',
  'ITO Utility Token': 'IUT',
  'Internet of People': 'IOP',
  Xuez: 'XUEZ',
  Rubies: 'RBIES',
  'Cash Tech': 'CATE',
  FirstCoin: 'FRST',
  ZCore: 'ZCR',
  Energycoin: 'ENRG',
  Grimm: 'GRIMM',
  SteepCoin: 'STEEP',
  PegNet: 'PEG',
  'Bintex Futures': 'BNTX',
  'Unicly Genesis Collection': 'UUNICLY',
  Impleum: 'IMPL',
  'Ormeus Cash': 'OMC',
  CryptoVerificationCoin: 'CVCC',
  Arionum: 'ARO',
  'BitBlocks Finance': 'BBKFI',
  Rimbit: 'RBT',
  Giant: 'GIC',
  'Simple Software Solutions': 'SSS',
  Bitnation: 'XPAT',
  Pirl: 'PIRL',
  Bolivarcoin: 'BOLI',
  BitSend: 'BSD',
  Bionic: 'BNC',
  TCASH: 'TCASH',
  GMB: 'GMB',
  ROAD: 'ROAD',
  Bitradio: 'BRO',
  aWSB: 'aWSB',
  'Coin2.1': 'C2',
  Worldcore: 'WRC',
  'Tutti Frutti': 'TFF',
  Civitas: 'CIV',
  Uptrennd: '1UP',
  EveriToken: 'EVT',
  Defis: 'XGM',
  'wave edu coin': 'WEC',
  BERNcash: 'BERN',
  GuccioneCoin: 'GCC',
  EnterCoin: 'ENTRC',
  ELTCOIN: 'ELTCOIN',
  Gravity: 'GZRO',
  Elementeum: 'ELET',
  Privatix: 'PRIX',
  'Streamit Coin': 'STREAM',
  'Island Coin': 'ISLE',
  SBank: 'STS',
  BitcoiNote: 'BTCN',
  CBDAO: 'BREE',
  EUNOMIA: 'ENTS',
  ETHplode: 'ETHPLO',
  'YFIVE FINANCE': 'YFIVE',
  Rupee: 'RUP',
  'SF Capital': 'SFCP',
  Biotron: 'BTRN',
  Citadel: 'CTL',
  VoteCoin: 'VOT',
  Suretly: 'SUR',
  Photon: 'PHO',
  PostCoin: 'POST',
  PureVidz: 'VIDZ',
  Veles: 'VLS',
  'Baguette Token': 'BGTT',
  Micromines: 'MICRO',
  CPUchain: 'CPU',
  Ratecoin: 'XRA',
  YENTEN: 'YTN',
  'Hyper Finance': 'HYFI',
  Webcoin: 'WEB',
  'Joint Ventures': 'JOINT',
  GenesisX: 'XGS',
  'BitGuild PLAT': 'PLAT',
  HyperAlloy: 'ALLOY',
  Donu: 'DONU',
  'MoneroV ': 'XMV',
  FidexToken: 'FEX',
  BlockMesh: 'BMH',
  KWHCoin: 'KWH',
  'Herbalist Token': 'HERB',
  'Bitcoin Incognito': 'XBI',
  BitRewards: 'BIT',
  'Fantasy Sports': 'DFS',
  Mchain: 'MAR',
  'Provoco Token': 'VOCO',
  Onix: 'ONX',
  ICOBID: 'ICOB',
  Cryptobuyer: 'XPT',
  'Global Currency Reserve': 'GCR',
  'Datarius Credit': 'DTRC',
  SuperCoin: 'SUPER',
  'Digital Money Bits': 'DMB',
  EDRCoin: 'EDRC',
  KUN: 'KUN',
  SafeCapital: 'SCAP',
  ArbitrageCT: 'ARCT',
  CryptoEnergy: 'CNRG',
  'Yield Stake Finance': 'YI12',
  CaluraCoin: 'CLC',
  'Natmin Pure Escrow': 'NAT',
  Trexcoin: 'TREX',
  Martkist: 'MARTK',
  'Theresa May Coin': 'MAY',
  Waletoken: 'WTN',
  Arepacoin: 'AREPA',
  Akroma: 'AKA',
  WinCash: 'WCC',
  PosEx: 'PEX',
  StarterCoin: 'STAC',
  Neutron: 'NTRN',
  ARAW: 'ARAW',
  DraftCoin: 'DFT',
  Desire: 'DSR',
  Narrative: 'NRVE',
  FuzzBalls: 'FUZZ',
  Exosis: 'EXO',
  Arion: 'ARION',
  XOVBank: 'XOV',
  Commercium: 'CMM',
  Atheios: 'ATH',
  MultiCoinCasino: 'MCC',
  'Ether Kingdoms Token': 'IMP',
  SnodeCoin: 'SND',
  'Thore Cash': 'TCH',
  iBTC: 'IBTC',
  Phantomx: 'PNX',
  'noob.finance': '$NOOB',
  Raise: 'RAISE',
  MFCoin: 'MFC',
  CyberMusic: 'CYMT',
  'Neuromorphic.io': 'NMP',
  'FUZE Token': 'FUZE',
  'Bitcoin Adult': 'BTAD',
  DNotes: 'NOTE',
  Paypex: 'PAYX',
  Cryptrust: 'CTRT',
  FUTURAX: 'FTXT',
  Centurion: 'CNT',
  ShowHand: 'HAND',
  'Vortex Defi': 'VTX',
  Pyrk: 'PYRK',
  ProxyNode: 'PRX',
  'SkyHub Coin': 'SHB',
  'X-Coin': 'XCO',
  'BoatPilot Token': 'NAVY',
  MktCoin: 'MLM',
  PolypuX: 'PUX',
  MustangCoin: 'MST',
  'SCRIV NETWORK': 'SCRIV',
  ParkByte: 'PKB',
  'Global Crypto Alliance': 'CALL',
  TajCoin: 'TAJ',
  ZeusNetwork: 'ZEUS',
  TravelNote: 'TVNT',
  ANON: 'ANON',
  'Plus-Coin': 'NPLC',
  'Crowd Machine': 'CMCT',
  Zealium: 'NZL',
  GeyserCoin: 'GSR',
  'Zuflo Coin': 'ZFL',
  Spectrum: 'SPT',
  Thingschain: 'TIC',
  'UNICORN Token': 'UNI',
  UChain: 'UCN',
  WeBlock: 'WON',
  Rewardiqa: 'REW',
  SparksPay: 'SPK',
  WXCOINS: 'WXC',
  Ultragate: 'ULG',
  Dreamcoin: 'DRM',
  MedicCoin: 'MEDIC',
  STRAKS: 'STAK',
  'Panda Yield': 'BBOO',
  Havy: 'HAVY',
  'High Voltage': 'HVCO',
  'Bitcoin Zero': 'BZX',
  Bidesk: 'BDK',
  '4NEW': 'KWATT',
  'BTC Lite': 'BTCL',
  SharedStake: 'SGT',
  'Sparkle Loyalty': 'SPRKL',
  BowsCoin: 'BSC',
  Dollarcoin: 'DLC',
  Shivers: 'SHVR',
  'ROIyal Coin': 'ROCO',
  'Taklimakan Network': 'TAN',
  Veltor: 'VLT',
  Bitcoiin: 'B2G',
  Digiwage: 'WAGE',
  CRDT: 'CRDT',
  'Alchemint Standards': 'SDS',
  AmsterdamCoin: 'AMS',
  BLAST: 'BLAST',
  ZINC: 'ZINC',
  Paytomat: 'PTI',
  Celeum: 'CLX',
  'Space Cow Boy': 'SCB',
  Knekted: 'KNT',
  Nekonium: 'NUKO',
  MESEFA: 'SEFA',
  'Tourist Token': 'TOTO',
  Ellaism: 'ELLA',
  'Halving Token': 'HALV',
  XPA: 'XPA',
  'Kush Finance': 'KSEED',
  CREDIT: 'CREDIT',
  SovranoCoin: 'SVR',
  'Zenswap Network Token': 'ZNT',
  SpreadCoin: 'SPR',
  Payfair: 'PFR',
  Ccore: 'CCO',
  MDtoken: 'MDTK',
  'Rigel Finance': 'RIGEL',
  Californium: 'CF',
  Acoin: 'ACOIN',
  'Bitcoin 21': 'XBTC21',
  Squorum: 'SQR',
  Cream: 'CRM',
  'APR Coin': 'APR',
  'Quantis Network': 'QUAN',
  Datacoin: 'DTC',
  Boolberry: 'BBR',
  Kalkulus: 'KLKS',
  'Kebab Token': 'KEBAB',
  HyperQuant: 'HQT',
  MarteXcoin: 'MXT',
  SWYFT: 'SWYFTT',
  Eurocoin: 'EUC',
  'Decentralized Asset Trading Platform': 'DATP',
  onLEXpa: 'onLEXpa',
  CrevaCoin: 'CREVA',
  Unify: 'UNIFY',
  BitCoal: 'COAL',
  'Mainstream For The Underground': 'MFTU',
  Italo: 'XTA',
  Aeryus: 'AER',
  DistX: 'DISTX',
  Bonpay: 'BON',
  Nyerium: 'NYEX',
  Swirge: 'SWG',
  Castle: 'CSTL',
  Quebecoin: 'QBC',
  ParallelCoin: 'DUO',
  'Mobile Crypto Pay Coin': 'MCPC',
  IFX24: 'IFX24',
  'Alpha Coin': 'APC',
  SongCoin: 'SONG',
  'Gossip Coin': 'GOSS',
  Comet: 'CMT',
  Carebit: 'CARE',
  'S.Finance': 'SFG',
  Feellike: 'FLL',
  'Abitshadow Token': 'ABST',
  Litecred: 'LTCR',
  IGToken: 'IG',
  Blakecoin: 'BLC',
  'Yearn Finance Bit': 'YFBT',
  SeChain: 'SNN',
  'Connect Coin': 'XCON',
  'Newton Coin Project': 'NCP',
  ImageCash: 'IMGC',
  'Gold Poker': 'GPKR',
  YoloCash: 'YLC',
  GravityCoin: 'GXX',
  GoHelpFund: 'HELP',
  Zayedcoin: 'ZYD',
  SpeedCash: 'SCS',
  Kemacoin: 'KEMA',
  'HashNet BitEco': 'HNB',
  'EXMR FDN': 'EXMR',
  'Hyper Speed Network': 'HSN',
  'YFFII Finance': 'YFFII',
  'Bitcoin CZ': 'BCZ',
  'Luna Coin': 'LUNA',
  'Prime-XI': 'PXI',
  ARbit: 'ARB',
  'Independent Money System': 'IMS',
  Cabbage: 'CAB',
  'JavaScript Token': 'JS',
  CCUniverse: 'UVU',
  'Kabberry Coin': 'KKC',
  'Electrum Dark': 'ELD',
  Galilel: 'GALI',
  Netrum: 'NTR',
  VectorAI: 'VEC2',
  OREO: 'ORE',
  'Vivid Coin': 'VIVID',
  PAXEX: 'PAXEX',
  'Asura Coin': 'ASA',
  Coinonat: 'CXT',
  PLNcoin: 'PLNC',
  Guider: 'GDR',
  Scanetchain: 'SWC',
  Aeron: 'ARNX',
  Bitvolt: 'VOLT',
  BitMoney: 'BIT',
  Ragnarok: 'RAGNA',
  Iconic: 'ICON',
  Diligence: 'IRA',
  Abulaba: 'AAA',
  Apollon: 'XAP',
  'Wild Beast Block': 'WBB',
  ScooterCoin: 'SCOOT',
  ETHPlus: 'ETHP',
  'Dash Green': 'DASHG',
  iBank: 'IBANK',
  XDNA: 'XDNA',
  'ALL BEST ICO': 'ALLBI',
  LitecoinToken: 'LTK',
  Klimatas: 'KTS',
  FinNexus: 'FNX',
  ECOSC: 'ECU',
  SocialCoin: 'SOCC',
  Helex: 'HLX',
  Cannation: 'CNNC',
  Bulleon: 'BUL',
  'The Currency Analytics': 'TCAT',
  'LiteCoin Ultra': 'LTCU',
  Dinero: 'DIN',
  Bitcoinus: 'BITS',
  'Save and Gain': 'SANDG',
  'Compound Coin': 'COMP',
  'Crystal Token': 'CYL',
  IBStoken: 'IBS',
  DOWCOIN: 'DOW',
  Galactrum: 'ORE',
  Staker: 'STR',
  Merebel: 'MERI',
  MoX: 'MOX',
  SONO: 'SONO',
  Storeum: 'STO',
  Argus: 'ARGUS',
  PonziCoin: 'PONZI',
  'KZ Cash': 'KZC',
  MNPCoin: 'MNP',
  Helpico: 'HELP',
  Concoin: 'CONX',
  PlatinumBAR: 'XPTX',
  Aigang: 'AIX',
  Nibble: 'NBXC',
  Stakinglab: 'LABX',
  DABANKING: 'DAB',
  Ouroboros: 'OURO',
  'Innovative Bioresearch Classic': 'INNBCL',
  Agrolot: 'AGLT',
  WETH: 'WETH',
  'Wrapped AVAX': 'WAVAX',
  FLEX: 'FLEX',
  'Beta Finance': 'BETA',
  'Wrapped Fantom': 'WFTM',
  'Spell Token': 'SPELL',
  Jasmy: 'JASMY',
  TimeCoinProtocol: 'TMCN',
  'Radio Caca': 'RACA',
  Olympus: 'OHM',
  Wonderland: 'TIME',
  Bloktopia: 'BLOK',
  'Compound USD Coin': 'CUSDC',
  'XT.com Token': 'XT',
  'Compound Dai': 'CDAI',
  'Global AEX Token': 'GAT',
  'Magic Internet Money': 'MIM',
  Metahero: 'HERO',
  'Gains Farm': 'GFARM2',
  JOE: 'JOE',
  'Gro DAO Token': 'GRO',
  MinePlex: 'PLEX',
  'Popsicle Finance': 'ICE',
  'Wrapped Matic': 'WMATIC',
  'Heroes & Empires': 'HE',
  'Gold Coin Reserve': 'GCR',
  'Gera Coin': 'GERA',
  'EverGrow Coin': 'EGC',
  SOMESING: 'SSX',
  CryptoMines: 'ETERNAL',
  'Wrapped LUNA Token': 'WLUNA',
  'ARCx (old)': 'ARC',
  Braintrust: 'BTRST',
  'KLAYswap Protocol': 'KSP',
  'Floki Inu': 'FLOKI',
  'Amun Ether 3x Daily Long': 'ETH3L',
  PolyPlay: 'PLAY',
  'Linkflow Finance': 'LF',
  'Australian Dollar Token': 'AUDT',
  OKExChain: 'OKT',
  'Kuma Inu': 'KUMA',
  'Inverse Finance': 'INV',
  'Torii Finance': 'TORII',
  Orca: 'ORCA',
  'Frapped USDT': 'fUSDT',
  'Plant Vs Undead': 'PVU',
  'Media Network': 'MEDIA',
  'Beacon ETH': 'BETH',
  Qredo: 'QRDO',
  'Defina Finance': 'FINA',
  BTCUP: 'BTCUP',
  'Compound USDT': 'CUSDT',
  O3Swap: 'O3',
  'Baby Doge Coin': 'BabyDoge',
  Synapse: 'SYN',
  '3X Long Bitcoin Token': 'BULL',
  'Akita Inu': 'AKITA',
  DOTUP: 'DOTUP',
  'PokerFI.Finance': 'POKERFI',
  Bholdus: 'BHO',
  ETHUP: 'ETHUP',
  'Conscious Value Network': 'CVNT',
  Human: 'HMT',
  BTCDOWN: 'BTCDOWN',
  'GOMA Finance': 'GOMA',
  Saitama: 'SAITAMA',
  CherrySwap: 'CHE',
  StarLink: 'SLNV2',
  'Position Exchange': 'POSI',
  Tokemak: 'TOKE',
  ETHDOWN: 'ETHDOWN',
  'Kawaii Islands': 'KWT',
  BNBUP: 'BNBUP',
  DeRace: 'DERC',
  'Amun Bitcoin 3x Daily Long': 'BTC3L',
  ADAX: 'ADAX',
  'Doge Killer': 'LEASH',
  'ITAM Games': 'ITAM',
  'Thetan Arena': 'THG',
  'Sienna (ERC20)': 'wSIENNA',
  sKLAY: 'SKLAY',
  FinexboxToken: 'FNB',
  'ETH 2x Flexible Leverage Index': 'ETH2X-FLI',
  Warena: 'RENA',
  'Bitcoin TRC20': 'BTCT',
  'Global China Cash': 'CNC',
  HarmonyPad: 'HPAD',
  'SIMP Token': 'SIMP',
  Spookyswap: 'BOO',
  'Geist Finance': 'GEIST',
  PointPay: 'PXP',
  Valkyrio: 'VALK',
  XRPUP: 'XRPUP',
  'Wrapped Centrifuge': 'WCFG',
  'Wanaka Farm': 'WANA',
  BunnyPark: 'BP',
  'Kishu Inu': 'KISHU',
  'Moon Rabbit': 'AAA',
  Stratos: 'STOS',
  XRPDOWN: 'XRPDOWN',
  '3X Long Ethereum Token': 'ETHBULL',
  TRONPAD: 'TRONPAD',
  'Wrapped Huobi Token': 'WHT',
  Dopex: 'DPX',
  'Rangers Protocol': 'RPG',
  Equilibria: 'XEQ',
  Thinkium: 'TKM',
  'CyberDragon Gold': 'GOLD',
  SubGame: 'SGB',
  Trustpad: 'TPAD',
  'Cryptex Finance': 'CTX',
  Filda: 'FILDA',
  'RAI Finance': 'RAI',
  ShibX: '$ShibX',
  'Brazilian Digital Token': 'BRZ',
  'Lovely Inu': 'LOVELY',
  TrusterCoin: 'TSC',
  'Gold Secured Currency': 'GSX',
  BNBDOWN: 'BNBDOWN',
  Songbird: 'SGB',
  'Pig Finance': 'PIG',
  Alchemist: 'MIST',
  Cope: 'COPE',
  'Monsters Clan': 'MONS',
  'King Swap': '$KING',
  Truebit: 'TRU',
  DOTDOWN: 'DOTDOWN',
  LEXIT: 'LEXI',
  Unizen: 'ZCX',
  'Doctors Coin': 'DRS',
  'Adadex Tools': 'ADAT',
  'Sunny Aggregator': 'SUNNY',
  'Defi For You': 'DFY',
  Starpunk: 'SRP',
  'Orion Money': 'ORION',
  Cyclos: 'CYS',
  XTZUP: 'XTZUP',
  'Paypolitan Token': 'EPAN',
  'Amun Bitcoin 3x Daily Short': 'BTC3S',
  TORG: 'TORG',
  'Tether EURt': 'EURT',
  Sperax: 'SPA',
  'Artwork NFT': 'ANFT',
  LINKUP: 'LINKUP',
  'Value Liquidity': 'VALUE',
  FILUP: 'FILUP',
  'Hot Cross': 'HOTCROSS',
  'Amun Ether 3x Daily Short': 'ETH3S',
  'Hoo Token': 'HOO',
  'Polaris Share': 'POLA',
  'Crypto Cars World': 'CARS',
  SXPUP: 'SXPUP',
  'Dark Energy Crystals': 'DEC',
  Homeros: 'HMR',
  'CryptoZoo  (new)': 'ZOO',
  Avalaunch: 'XAVA',
  Netvrk: 'NTVRK',
  Gamestarter: 'GAME',
  Saber: 'SBR',
  YooShi: 'YOOSHI',
  Paycoin: 'PCI',
  BAE: 'BAE',
  Flokinomics: 'FLOKIN',
  Paribus: 'PBX',
  'Vectorspace AI': 'VXV',
  AnchorSwap: 'ANCHOR',
  Multiverse: 'AI',
  'Mars Ecosystem Token': 'XMS',
  LTCUP: 'LTCUP',
  Ekta: 'EKTA',
  'XCAD Network': 'XCAD',
  'Mrweb Finance': 'AMA',
  VEROX: 'VRX',
  CoPuppy: 'CP',
  Chronicle: 'XNL',
  'Morpheus Token': 'MORPH',
  'FEG Token': 'FEG',
  XTZDOWN: 'XTZDOWN',
  'Green Energy Coin': 'GEC',
  'EIFI FINANCE': 'EIFI',
  xSUSHI: 'XSUSHI',
  'Octopus Network': 'OCT',
  'Women Empowerment Token': 'WEMP',
  BladeWarrior: 'BLADE',
  'Sunflower Finance': 'SFO',
  ANIVERSE: 'ANV',
  'Adappter Token': 'ADP',
  Integral: 'ITGR',
  'Crypto Gladiator Shards': 'CGS',
  'Block Commerce Protocol': 'BCP',
  Futureswap: 'FST',
  Gelato: 'GEL',
  'Nano Shiba Inu': 'NANOSHIBA',
  Sovryn: 'SOV',
  CryptoCars: 'CCAR',
  'safeswap.online': 'SWAP',
  SolRazr: 'SOLR',
  SuperBid: 'SUPERBID',
  SUSHIUP: 'SUSHIUP',
  'Ryoshis Vision': 'RYOSHI',
  AetherV2: 'ATH',
  'Basis Gold Share': 'BAGS',
  'The Crypto Prophecies': 'TCP',
  'Secret (ERC20)': 'WSCRT',
  DefiBox: 'BOX',
  SEED: 'SEED',
  FILDOWN: 'FILDOWN',
  G999: 'G999',
  LuckyPig: 'LuckyPig',
  Shirtum: 'SHI',
  'Golden Ratio Token': 'GRT',
  Pokmonsters: 'POK',
  'Yield Yak': 'YAK',
  Lumenswap: 'LSP',
  'ALP Coin': 'ALP',
  Moonpot: 'POTS',
  GreenMoon: 'GRM',
  'New BitShares': 'NBS',
  'POP Network Token': 'POP',
  Edgecoin: 'EDGT',
  'Biconomy Exchange Token': 'BIT',
  Franklin: 'FLY',
  Lendhub: 'LHB',
  Memecoin: 'MEM',
  'UFO Gaming': 'UFO',
  'KICK.IO': 'KICK',
  ADAUP: 'ADAUP',
  'Wrapped OKT': 'WOKT',
  Hamster: 'HAM',
  'CryptoArt.Ai': 'CART',
  'HurricaneSwap Token': 'HCT',
  Nahmii: 'NII',
  HalfPizza: 'PIZA',
  'OEC BTC': 'BTCK',
  'Coinary Token': 'CYT',
  KINE: 'KINE',
  'Wallfair.io': 'WFAIR',
  PoolTogether: 'POOL',
  'BRCP TOKEN': 'BRCP',
  'Xeta Reality': 'XETA',
  'Galabet Casino': 'GALABET',
  CateCoin: 'CATE',
  Hdac: 'HDAC',
  'Tokyo AU': 'TOKAU',
  EQIFI: 'EQX',
  DMD: 'DMD',
  'vEmpire DDAO': 'VEMP',
  Premia: 'PREMIA',
  MarsRise: 'MARSRISE',
  'CARD.STARTER': 'CARDS',
  'Bitcoin God': 'GOD',
  AvaXlauncher: 'AVXL',
  PrinceFloki: 'PrinceFloki',
  Kollect: 'KOL',
  'DeFi Pulse Index': 'DPI',
  'Terran Coin': 'TRR',
  LunaChow: 'LUCHOW',
  BambooDeFi: 'BAMBOO',
  Opulous: 'OPUL',
  'AquaGoat.Finance': 'AQUAGOAT',
  VidyX: 'VIDYX',
  '3x Long XRP Token': 'XRPBULL',
  DogeGF: 'DOGEGF',
  'Frosted Cake': 'FROSTEDCAKE',
  MetaMUI: 'MMUI',
  Realm: 'REALM',
  Enjinstarter: 'EJS',
  'Gem Guardian': 'GEMG',
  'Dimitra Token': 'DMTR',
  'Wise Token': 'WISE',
  Firdaos: 'FDO',
  'Coco Swap': 'COCO',
  Pearl: 'PEARL',
  SXPDOWN: 'SXPDOWN',
  'KogeCoin.io': 'KOGECOIN',
  Catgirl: 'CATGIRL',
  DeCredit: 'CDTC',
  'HBTC Captain Token': 'HBC',
  'All.me': 'ME',
  'Falcon 9': 'F9',
  Findora: 'FRA',
  STING: 'STN',
  Bitcicoin: 'BITCI',
  Larix: 'LARIX',
  'ZOO Crypto World': 'ZOO',
  'Union Fair Coin': 'UFC',
  MAI: 'MIMATIC',
  AAVEUP: 'AAVEUP',
  DeepCoin: 'DC',
  'IX Swap': 'IXS',
  'Empire Token': 'EMPIRE',
  'Starmon Metaverse': 'SMON',
  'Genebank Token': 'GNBT',
  NFTLaunch: 'NFTL',
  Zelwin: 'ZLW',
  'Baby Floki Billionaire': 'BabyFB',
  botXcoin: 'BOTX',
  'ARC Governance': 'ARCX',
  FolgoryUSD: 'USDF',
  Vectorium: 'VECT',
  'Battle Pets': 'PET',
  'Dragon Warrior': 'GON+',
  'Sona Network': 'SONA',
  WAXE: 'WAXE',
  KleeKai: 'KLEE',
  'Uberstate RIT 2.0': 'RIT20',
  Kirobo: 'KIRO',
  'Doont Buy': 'DBUY',
  MoonStarter: 'MNST',
  Celestial: 'CELT',
  'EMOGI Network': 'LOL',
  CPCoin: 'CPC',
  'Ally Direct Token': 'DRCT',
  Throne: 'THN',
  Cratos: 'CRTS',
  'Eleven Finance': 'ELE',
  'HitBTC Token': 'HIT',
  'CryptoBlades Kingdoms': 'KING',
  'Teddy Cash': 'TEDDY',
  Tenset: '10SET',
  '3X Long Chainlink Token': 'LINKBULL',
  DogeMoon: 'DGMOON',
  'Baby Shiba Inu': 'BABYSHIBAINU',
  Hudi: 'HUDI',
  TopChain: 'TOPC',
  Altura: 'ALU',
  MobieCoin: 'MBX',
  Launchpool: 'LPOOL',
  'Fruits Eco': 'FRTS',
  '3X Long Cosmos Token': 'ATOMBULL',
  AirCoin: 'AIR',
  BlowUP: '$BLOW',
  UNIUP: 'UNIUP',
  '3X Long Matic Token': 'MATICBULL',
  SafeBull: 'SAFEBULL',
  'Life Crypto': 'LIFE',
  'World of Cryptia': 'CRYPT',
  MilliMeter: 'MM',
  'BSC TOOLS': 'TOOLS',
  'Lido wstETH': 'WSTETH',
  'EPIK Prime': 'EPIK',
  MiamiCoin: 'MIA',
  MixTrust: 'MXT',
  DeathRoad: 'DRACE',
  AAVEDOWN: 'AAVEDOWN',
  ACCESSLAUNCHER: 'ACX',
  ADADOWN: 'ADADOWN',
  TEN: 'TENFI',
  InfinitUp: 'IUP',
  OVR: 'OVR',
  'DBX Digital Ecosystem': 'DBX',
  'Brokoli Network': 'BRKL',
  MemeFlate: '$MFLATE',
  Swapz: 'SWAPZ',
  'Cirus Foundation': 'CIRUS',
  'Upper Pound': 'GBPU',
  'Dark Frontiers': 'DARK',
  'MVP Coin': 'MVP',
  '3X Long Cardano Token': 'ADABULL',
  'BitcoMine Token': 'BME',
  '1INCHUP': '1INCHUP',
  Starter: 'START',
  'Morphie Network': 'MRFI',
  'UNITED EMIRATE DECENTRALIZED COIN.': 'UEDC',
  'Convex CRV': 'CVXCRV',
  'AGOV (ANSWER Governance)': 'AGOV',
  MarX: 'MARX',
  CropperFinance: 'CRP',
  Nimbus: 'NBU',
  '3X Long Dogecoin Token': 'DOGEBULL',
  MatrixETF: 'MDF',
  TOKOK: 'TOK',
  QANplatform: 'QANX',
  'APWine Finance': 'APW',
  'Diamond Boyz Coin': 'DBZ',
  'Earn Defi Coin': 'EDC',
  'Octopus Protocol': 'OPS',
  'Cake Monster': 'MONSTA',
  'Penguin Finance': 'PEFI',
  'Folder Protocol': 'FOL',
  'Ulti Arena': 'ULTI',
  Bombcrypto: 'BCOIN',
  'HLP Token': 'HLP',
  'Dope Wars Paper': 'PAPER',
  PalGold: 'PALG',
  AirNFTs: 'AIRT',
  'YAY Games': 'YAY',
  'Alchemix USD': 'ALUSD',
  FileStar: 'STAR',
  LINKDOWN: 'LINKDOWN',
  MultiPad: 'MPAD',
  GreenZoneX: 'GZX',
  'Hina Inu': '$HINA',
  EverRise: 'RISE',
  BullPerks: 'BLP',
  MContent: 'MCONTENT',
  'HoneyMoon Finance': 'MOON',
  Bitcoiva: 'BCA',
  Qubit: 'QBT',
  Genshiro: 'GENS',
  'Daisy Launch Pad': 'DAISY',
  '1INCHDOWN': '1INCHDOWN',
  'B.Protocol': 'BPRO',
  'DeFi Warrior (FIWA)': 'FIWA',
  'DNAxCAT Token': 'DXCT',
  DeFido: 'DEFIDO',
  'Port Finance': 'PORT',
  EOSDOWN: 'EOSDOWN',
  'Monsoon Finance': 'MCASH',
  'VYNK CHAIN': 'VYNC',
  'Nimbus Governance Token': 'GNBU',
  UniWorld: 'UNW',
  Liquidus: 'LIQ',
  'Mini Avalanche': 'MAVAX',
  BiLira: 'TRYB',
  TriipMiles: 'TIIM',
  'Meme Lordz': '$LORDZ',
  '3x Long Tezos Token': 'XTZBULL',
  'Egoras (old)': 'EGR',
  'Lido for Solana': 'STSOL',
  ARCS: 'ARX',
  Kalao: 'KLO',
  OpenSwap: 'OSWAP',
  'THORChain (ERC20)': 'RUNE',
  DogeBull: 'DOGEBULL',
  Artex: 'ARTEX',
  'Keanu Inu': 'KEANU',
  Answerly: 'ANSR',
  ZYX: 'ZYX',
  'Occam.Fi': 'OCC',
  BinStarter: 'BSR',
  Birb: 'BIRB',
  Instaraise: 'INSTA',
  DyzToken: 'DYZ',
  sBTC: 'SBTC',
  'Visor.Finance': 'VISR',
  'Decentralized data crypto system': 'DCS',
  'GSPI Shopping.io Governance': 'GSPI',
  'NewB.Farm': 'NEWB',
  'Storage Area Network Anywhere': 'SANA',
  Medacoin: 'MEDA',
  IDK: 'IDK',
  MoonEdge: 'MOONED',
  'Lion Token': 'LION',
  TRXUP: 'TRXUP',
  'Block Farm': 'BFC',
  Solanax: 'SOLD',
  Demeter: 'DMT',
  MobileCoin: 'MOB',
  HOPR: 'HOPR',
  Lightcoin: 'LHC',
  'Universe.XYZ': 'XYZ',
  'GINCOIN (Global  Interest  Rate)': 'GIN',
  '3x Long EOS Token': 'EOSBULL',
  'Funder One Capital': 'FUNDX',
  EscoinToken: 'ELG',
  'Index Cooperative': 'INDEX',
  UNIDOWN: 'UNIDOWN',
  'Project Quantum': 'QBIT',
  AladdinDAO: 'ALD',
  MOR: 'MOR',
  '3X Short Bitcoin Token': 'BEAR',
  PROXI: 'CREDIT',
  'PRIVATEUM INITIATIVE': 'PVM',
  XLMUP: 'XLMUP',
  'My Crypto Heroes': 'MCHC',
  PuddingSwap: 'PUD',
  PORNROCKET: 'PORNROCKET',
  'Liti Capital': 'WLITI',
  'DeepSpace Token': 'DXO',
  PolkaFantasy: 'XP',
  A2DAO: 'ATD',
  'PANCAKE HUNNY': 'HUNNY',
  'Upper Euro': 'EURU',
  'Wild Credit': 'WILD',
  'Luxurious Pro Network Token': 'LPNT',
  'Mello Token': 'MELLO',
  CryptoBank: 'CBANK',
  StrikeCoin: 'STRIKE',
  JOJO: 'JOJO',
  'Continuum World': 'UM',
  'Roseon Finance': 'ROSN',
  Cofinex: 'CNX',
  'Leonicorn Swap': 'LEOS',
  Polysage: 'SAGE',
  BankSocial: 'BSL',
  Pocoland: 'POCO',
  Polkacity: 'POLC',
  DinoX: 'DNXC',
  Multigame: 'MULTI',
  'WaykiChain Governance Coin': 'WGRT',
  'Upper Dollar': 'USDU',
  'Ecosystem Coin Network': 'ECN',
  'Genie Protocol': 'GNP',
  BscArmy: 'BARMY',
  'Uno Re': 'UNO',
  'Wojak Finance': 'WOJ',
  'Green Beli': 'GRBE',
  WanSwap: 'WASP',
  PlayAndLike: 'PAL',
  UBU: 'UBU',
  Calcifer: 'CALCIFER',
  'Proof Of Liquidity': 'POL',
  Channels: 'CAN',
  NASDEX: 'NSDX',
  'Feisty Doge NFT': 'NFD',
  'We Save Moon': 'SAVEMOON',
  'Hanzo Inu': 'HNZO',
  'Global Digital Content': 'GDC',
  'Polar Sync': 'POLAR',
  Sonar: 'PING',
  'Synapse Network': 'SNP',
  'Dot Finance': 'PINK',
  PolyDoge: 'POLYDOGE',
  cCOMP: 'CCOMP',
  Pando: 'PANDO',
  'Goji Crypto': 'HANU',
  'Cacti Club': 'CACTI',
  Madagascar: '$TIME',
  Dynamix: 'DYNA',
  '3X Long BNB Token': 'BNBBULL',
  'Wrapped Moonriver': 'WMOVR',
  'DeSpace Protocol': 'DES',
  Minifootball: 'MINIFOOTBALL',
  'Lux Bio Cell': 'LBXC',
  'Small dogecoin': 'SDOG',
  'Brazil National Fan Token': 'BFT',
  'Green Climate World': 'WGC',
  'LUFFY INU': 'LUFFY',
  Sake: 'SAK3',
  SafeLaunch: 'SFEX',
  'FOMO BABY': 'FOMOBABY',
  'SpacePort Universe': 'SPU',
  Portify: 'PFY',
  Medium: 'MDM',
  'Lucky Lion': 'LUCKY',
  'Xfinite Entertainment Token': 'XET',
  'Global Utility Smart Digital Token': 'GUSDT',
  Overlord: 'LORD',
  ASH: 'ASH',
  ApeRocket: 'SPACE',
  'Manifold Finance': 'FOLD',
  'Loon Network': 'LOON',
  'Pirate Coin Games': 'PirateCoin☠',
  Blockcloud: 'BLOC',
  WhaleRoom: 'WHL',
  'Tiger Cub': 'TCUB',
  AOS: 'AOS',
  'WallStreetBets DApp': 'WSB',
  'Gummy Beans': 'GUMMIE',
  'USDP Stablecoin': 'USDP',
  'Mission Helios': 'HELIOS',
  CREAMPYE: 'PYE',
  Safemars: 'SAFEMARS',
  'Wrapped WAN': 'WWAN',
  'Shiba Floki': 'FLOKI',
  'Pylon Eco Token': 'PETN',
  Metis: 'MTS',
  'Hotbit Token': 'HTB',
  'BKEX Token': 'BKK',
  Jigstack: 'STAK',
  TOMI: 'TOMI',
  PlentyCoin: 'PLENTYCOIN',
  'TON Crystal': 'TON',
  'PolyBeta Finance': 'BETA',
  Million: 'MM',
  'Woonkly Power': 'WOOP',
  'KSM Starter': 'KST',
  'Stone DeFi': 'STN',
  Afreum: 'AFR',
  'FRAKT Token': 'FRKT',
  'Bright Token': 'BRIGHT',
  'Yaki Gold': 'YAG',
  'iMe Lab': 'LIME',
  Echoin: 'EC',
  'Chain Games': 'CHAIN',
  'NFT Starter': 'NST',
  Carnomaly: 'CARR',
  SumSwap: 'SUM',
  GeroWallet: 'GERO',
  SIMARGL: 'SIMA',
  VAIOT: 'VAI',
  'Traders coin': 'TRDC',
  'Mini Kishu': 'MINIKISHU',
  'BNB Cash': 'BNBCH',
  CakeUp: 'CAKEUP',
  'JackPool.finance': 'JFI',
  'Vero Farm': 'VERO',
  'PL^Gnet': 'PLUG',
  BeforeCoinMarketCap: 'BCMC1',
  'Knight War - The Holy Trio': 'KWS',
  'Nominex Token': 'NMX',
  CashBackPro: 'CBP',
  'SMD COIN': 'SMD',
  HeroVerse: 'HER',
  Jejudoge: 'JEJUDOGE',
  Pkoin: 'PKOIN',
  NFTPad: 'NFTPAD',
  CardSwap: 'CSWAP',
  Weentar: '$WNTR',
  'Wrapped ECOMI': 'WOMI',
  'Hokkaidu Inu': 'HOKK',
  TAI: 'TAI',
  'Radix Protocol': 'XRD',
  RealFevr: 'FEVR',
  Giftedhands: 'GHD',
  Mute: 'MUTE',
  'Idea Chain Coin': 'ICH',
  'BT.Finance': 'BT',
  'NFTY Network': 'NFTY',
  'XP NETWORK': 'XPNET',
  GGDApp: 'GGTK',
  'Parrot Protocol': 'PRT',
  MyToken: 'MT',
  COIN: '$COIN',
  'Keisuke Inu': '$KEI',
  'Globe Derivative Exchange': 'GDT',
  AzeusX: 'AZX',
  'Less Network': 'LESS',
  'Planet Sandbox': 'PSB',
  'EpicHero 3D NFT': 'EPICHERO',
  'Lumi Credits': 'LUMI',
  'Compound 0x': 'CZRX',
  'BOY X HIGHSPEED': 'BXH',
  'Punk Vault (NFTX)': 'PUNK',
  KingDeFi: 'KRW',
  StartFi: 'STFI',
  'Vent Finance': 'VENT',
  YFIONE: 'YFO',
  'Lelouch Lamperouge': 'LELOUCH',
  'IRON Titanium Token': 'TITAN',
  Balkari: 'BKR',
  'StorX Network': 'SRX',
  Nobility: 'NBL',
  wanUSDT: 'WANUSDT',
  'Oxbull Solana': 'OXS',
  IOI: 'IOI',
  'Relay Token': 'RELAY',
  Thoreum: 'THOREUM',
  'pTokens BTC': 'PBTC',
  MacaronSwap: 'MCRN',
  'Nezuko Inu': 'NEZUKO',
  Gather: 'GTH',
  QiDao: 'QI',
  'Slam Token': 'SLAM',
  'Rhinos Finance': 'RHO',
  NFTBooks: 'NFTBS',
  'Loud Market': 'LOUD',
  YFIDOWN: 'YFIDOWN',
  PolkaCipher: 'CPHR',
  SMILE: 'SMILE',
  Bidao: 'BID',
  'Wrapped DucatusX': 'WDUCX',
  'Crypto Bay': 'PEARL',
  'UNION Protocol Governance Token': 'UNN',
  SupremeX: 'SXC',
  xYSL: 'XYSL',
  FNDZ: 'FNDZ',
  'Rabbit Finance': 'RABBIT',
  CoinWind: 'COW',
  'Holdex Finance': 'HOLDEX',
  'Kianite Finance': 'KIAN',
  '1X Short Ethereum Token': 'ETHHEDGE',
  SocialGood: 'SG',
  dexIRA: 'DEX',
  'OEC UNI': 'UNIK',
  'The Doge NFT': 'DOG',
  XLMDOWN: 'XLMDOWN',
  'Hive Dollar': 'HBD',
  Anypad: 'APAD',
  'En-Tan-Mo': 'ETM',
  Doxxed: 'DOX',
  '0x_nodes': 'BIOS',
  '3X Long Sushi Token': 'SUSHIBULL',
  LTCDOWN: 'LTCDOWN',
  'ViteX Coin': 'VX',
  Quidax: 'QDX',
  ToyDOGE: 'TDG',
  CrossWallet: 'CWT',
  CZFarm: 'CZF',
  CoFiX: 'COFI',
  'Fibswap DEx': 'FIBO',
  'BITICA DIGITAL CRYPTO CURRENCY': 'BDCC',
  'Dexit Finance': 'DXT',
  'Value Network': 'VNTW',
  SportX: 'SX',
  'Kawakami Inu': 'KAWA',
  Gravitoken: 'GRV',
  'CFX Quantum': 'CFXQ',
  DogeCola: 'DOGECOLA',
  'Polkasocial Network': 'PSN',
  'The Luxury': 'TLX',
  'Tracer DAO': 'TCR',
  CluCoin: 'CLU',
  YFIUP: 'YFIUP',
  'Planet Finance': 'AQUA',
  'BLACKHOLE PROTOCOL': 'BLACK',
  'Blind Boxes': 'BLES',
  'CAPITAL X CELL': 'CXC',
  handleFOREX: 'FOREX',
  Marginswap: 'MFI',
  'Good Bridging': 'GB',
  BabyLondon: 'BABYLONDON',
  'KAI INU': 'KAIINU',
  'Hypersign identity': 'HID',
  LaunchX: 'LNCHX',
  "Moonsta's Revenge": 'MTR',
  WaultSwap: 'WEX',
  SokuSwap: 'SOKU',
  'Mercurial Finance': 'MER',
  'Knit Finance': 'KFT',
  'Step Hero Soul': 'STEP',
  Wheelers: 'WHEEL',
  'Ethereum Lightning': 'ETLT',
  'Manga Token': '$MANGA',
  Youclout: 'YCT',
  PolkaEx: 'PKEX',
  Spice: 'SPICE',
  'Nico Robin Inu': 'ROBIN',
  'Kaby Arena': 'KABY',
  ShibaPup: 'SHIBAPUP',
  Polkaswap: 'PSWAP',
  dAppstore: 'DAPPX',
  WenMoon: 'WENMOON',
  'Block Monsters': 'MNSTRS',
  '300FIT NETWORK': 'FIT',
  'Frenchie Network': 'FREN',
  Instadapp: 'INST',
  'WELD MONEY': 'WELD',
  UniversalEnergyChain: 'UENC',
  'Citizen Finance': 'CIFI',
  'Plenty DeFi': 'PLENTY',
  '3x Long Litecoin Token': 'LTCBULL',
  'DUKE INU TOKEN': 'DUKE',
  'Cardence.io': '$CRDN',
  CryptoLion: 'CLION',
  QuiverX: 'QRX',
  'Aqua Pig': 'AQUAPIG',
  Divergence: 'DIVER',
  Dough: 'DOUGH',
  FlyPaper: 'STICKY',
  'DefiDollar DAO': 'DFD',
  Dotmoovs: 'MOOV',
  'Cryptoindex.com 100': 'CIX100',
  'Swift Finance': 'SWIFT',
  'Asian Fintech': 'AFIN',
  BabySafeMoon: 'BSFM',
  Kodi: 'KODI',
  GravitX: 'GRX',
  'TSA NFT': 'TSA',
  Treecle: 'TRCL',
  'Pasta Finance': 'PASTA',
  Lemond: 'LEMD',
  TribeOne: 'HAKA',
  'NFT Art Finance': 'NFTART',
  'Friends With Benefits Pro': 'FWB',
  'Metaverse Index': 'MVI',
  Unicly: 'UNIC',
  'Axia Protocol': 'AXIA',
  'Privapp Network': 'bPRIVA',
  '3X Long DeFi Index Token': 'DEFIBULL',
  aiRight: 'AIRI',
  TBCC: 'TBCC',
  'Facebook tokenized stock Bittrex': 'FB',
  'Real Trump Token V2': 'RTTV2',
  'Sanshu Inu': 'SANSHU',
  'Blue Baikal': 'BBC',
  'Wrapped Celo': 'WCELO',
  'Bitcoin Vault': 'BTCV',
  'Waggle Network': 'WAG',
  'Alibaba tokenized stock Bittrex': 'BABA',
  Etherlite: 'ETL',
  'Australian Safe Shepherd': 'ASS',
  Yieldly: 'YLDY',
  Betherchip: 'BEC',
  AUREO: 'AUR',
  'Banana.finance': 'BANANA',
  'Decentralized Social': 'DESO',
  'Quantum Assets': 'QA',
  'Doge Superbowl': 'DSBOWL',
  'Blocto Token': 'BLT',
  Utopia: 'UTOPIA',
  Dinosaureggs: 'DSG',
  'Gorilla Diamond': 'GDT',
  'Golden Roots': 'GDR',
  'DxSale Network': 'SALE',
  'Footie Plus': 'FOOTIE',
  'NDN Link': 'NDN',
  Zugacoin: 'SZCB',
  'Bogged Finance': 'BOG',
  Siren: 'SI',
  'RUSH COIN': 'RUSH',
  'BlackPearl Token': 'BPLC',
  'Joys Digital': 'JOYS',
  'Fat Doge': 'FOGE',
  'Luto Cash': 'LUTO',
  MetaSoldier: 'MSD',
  'AutoShark DEX': 'FINS',
  WEYU: 'WEYU',
  'Wrapped XDAI': 'wxDai',
  Maxonrow: 'MXW',
  MiraQle: 'MQL',
  'Dog Collar': 'COLLAR',
  Lien: 'LIEN',
  'Daikokuten Sama': 'DKKS',
  VKENAF: 'VKNF',
  DeversiFi: 'DVF',
  SoccerHub: 'SCH',
  'Tether Gold': 'XAUT',
  'Melo Token': 'MELO',
  Uniris: 'UCO',
  '1x Short Bitcoin Token': 'HEDGE',
  'GMR Finance': 'GMR',
  'Witch Token': 'WITCH',
  HUPAYX: 'HPX',
  'Passive Income': 'PSI',
  'The Luxury Coin': 'TLB',
  'Baby Floki (BSC)': 'BABYFLOKI',
  Vulkania: 'VLK',
  MiniDOGE: 'MINIDOGE',
  Decubate: 'DCB',
  'Yobit Token': 'YO',
  'Delos Defi': 'DELOS',
  'Feeder.finance': 'FEED',
  'BABY DOGE BILLIONAIRE': 'BABYDB',
  'PayPal tokenized stock FTX': 'PYPL',
  MeetPle: 'MPT',
  CoinxPad: 'CXPAD',
  NAFTY: 'NAFTY',
  'Zoe Cash': 'ZOE',
  'Sishi Finance': 'SISHI',
  'Crosschain IOTX': 'CIOTX',
  '3X Long Algorand Token': 'ALGOBULL',
  'Joker Coin': 'JOKER',
  'Euler Tools': 'EULER',
  'Charged Particles': 'IONX',
  Zyro: 'ZYRO',
  Vow: 'VOW',
  'CoShi Inu': 'COSHI',
  'GranX Chain': 'GRANX',
  'Wrapped KuCoin Token': 'WKCS',
  'Exchange Union': 'XUC',
  ElonTech: 'ETCH',
  'Green Shiba Inu (new)': 'GINUX',
  'MoonLift Protocol': 'MLTPX',
  ZooCoin: 'ZOO',
  'Meter Stable': 'MTR',
  Aldrin: 'RIN',
  'E-coin Finance': 'ECOIN',
  '100xCoin': '100X',
  'AEN Smart Token': 'AENS',
  'Defi Connect': 'DFC',
  PrivacySwap: 'PRV',
  Torum: 'XTM',
  xDeFi: 'XDEX',
  GameNFT: 'GNFT',
  'Flourishing AI': 'AI',
  'Simbcoin Swap': 'SMBSWAP',
  'Celo Euro': 'CEUR',
  'Save Planet Earth': 'SPE',
  Polylastic: 'POLX',
  'Ulgen Hash Power': 'UHP',
  'Bitcoin and Ethereum Standard Token': 'BEST',
  'Cricket Foundation': 'CRIC',
  Dungeonswap: 'DND',
  'Sportemon-Go': 'SGO',
  'Busy DAO': 'BUSY',
  CNNS: 'CNNS',
  Allbridge: 'ABR',
  xFund: 'XFUND',
  tBTC: 'TBTC',
  CoinsPaid: 'CPD',
  'Grape Network': 'GRAPE',
  'NNB Token': 'NNB',
  'One Share': 'ONS',
  'VIRVIA ONLINE SHOPPING': 'VDV',
  'Inferno Pay': 'IFO',
  Bulldogswap: 'BUDG',
  SUPERLAUNCH: 'SLA',
  MoneySwap: 'MSWAP',
  'Yearn Classic Finance': 'EARN',
  'LPI DAO': 'LPI',
  '1X Short BNB Token': 'BNBHEDGE',
  'AMC FIGHT NIGHT': 'AMC',
  'ESWAP.TUBE': 'TUBE2',
  'Flurry Finance': 'FLURRY',
  'Plutos Network': 'PLUT',
  CasinoCoin: 'CSC',
  PIGX: 'PIGX',
  Acet: 'ACT',
  'TacoCat Token': 'TCT',
  'Nami Inu': 'NAMI',
  'Dopex Rebate Token': 'RDPX',
  'Serum Ecosystem Token': 'SECO',
  'SnowCrash Token': 'NORA',
  'SIMBA Storage Token': 'SST',
  'Sukhavati Network': 'SKT',
  'The Forbidden Forest': 'FORESTPLUS',
  'Boost Coin': 'BOOST',
  'BNSD Finance': 'BNSD',
  BitcoinVend: 'BCVT',
  ShibaNova: 'NOVA',
  XTblock: 'XTT-B20',
  'Moon Nation Game': 'MNG',
  'Unlock Protocol': 'UDT',
  TRXDOWN: 'TRXDOWN',
  Pilot: 'PTD',
  PooCoin: 'POOCOIN',
  Yetucoin: 'YETU',
  'Tundra Token': 'TUNDRA',
  'Uzumaki Inu': 'UZUMAKI',
  'Kite Sync': 'KITE',
  'UniFi Protocol': 'UP',
  'Moonie NFT': 'MNY',
  LinkArt: 'LAR',
  'OnX Finance': 'ONX',
  'PACT community token': 'PACT',
  'Artery Network': 'ARTR',
  Alaya: 'ATP',
  'The Tokenized Bitcoin': 'imBTC',
  'Bitcoin Asset': 'BTA',
  'Baby Floki Coin': 'BABYFLOKICOIN',
  'Wiggly Finance': 'WGL',
  'CoinSwap Space': 'CSS',
  HOPPY: 'HOP',
  'Compound Uni': 'CUNI',
  Biswap: 'BSW',
  Latamcash: 'LMCH',
  'Orca AVAI': 'AVAI',
  RAKUN: 'RAKU',
  'HoneyFarm Finance': 'HONEY',
  'WaultSwap Polygon': 'WEXPOLY',
  OrcaDAO: 'ORCA',
  'Pinkslip Finance': 'PSLIP',
  'Light Defi': 'LIGHT',
  'Revolve Games': 'RPG',
  Handy: 'HANDY',
  'Elk Finance': 'ELK',
  'Kranz Token': 'KRZ',
  dFuture: 'DFT',
  Parabolic: 'PARA',
  'Project X': 'XIL',
  'HODL 2.0': 'HODL',
  CoviCoin: 'CVC',
  Mineral: 'MNR',
  'Baby Cake': 'BABYCAKE',
  Bytus: 'BYTS',
  'Mercor Finance': 'MRCR',
  Ridotto: 'RDT',
  Charli3: 'C3',
  'toad.network': 'TOAD',
  MARS4: 'MARS4',
  DeFIL: 'DFL',
  DefiCliq: 'CLIQ',
  'Capital.Finance': 'CAP',
  GreenTrust: 'GNT',
  'Rake Finance': 'RAK',
  QiSwap: 'QI',
  Thorstarter: 'XRUNE',
  'Football Stars': 'FootballStars',
  Cap: 'CAP',
  pBTC35A: 'pBTC35A',
  'BSC Gold': 'BSCGOLD',
  Alkimi: '$ADS',
  EthereumMax: 'EMAX',
  'Crypto Island': 'CISLA',
  Doren: 'DRE',
  Story: 'STORY',
  'Asia Coin': 'ASIA',
  'Olive.Cash': 'OLIVE',
  'GameStop tokenized stock FTX': 'GME',
  DRIFE: 'DRF',
  PayAccept: 'PAYT',
  'DNFT Protocol': 'DNF',
  'YearnAgnostic Finance': 'YFIAG',
  '3X Long TRX Token': 'TRXBULL',
  FUTUREXCRYPTO: 'FXC',
  WIZARD: 'WIZARD',
  'Phantom Protocol': 'PHM',
  'Arena Token': 'ARENA',
  'KuCoin LaunchPad': 'KCLP',
  'TCGCoin 2.0': 'TCG2',
  Daikicoin: 'DIC',
  ProSwap: 'PROS',
  'Energy Ledger': 'ELX',
  MarketMove: 'MOVE',
  RisingSun: 'RSUN',
  'Ryoshi Token': 'RYOSHI',
  Bzzone: 'BZZONE',
  WeStarter: 'WAR',
  BETFURY: 'BFG',
  Binapet: 'BPET',
  'Filecoin Standard Hashrate Token': 'FILST',
  'EA Token': 'EA',
  ExchangeCoin: 'EXCC',
  'Whole Network': 'NODE',
  CoinAlpha: 'ALP',
  ShieldEX: 'SLD',
  'Buff Doge Coin': 'DOGECOIN',
  PetKingdom: 'PKD',
  'Boss Token': 'BOSS',
  RoboFi: 'VICS',
  Babylons: 'BABI',
  '1Doge': '1DOGE',
  Yup: 'YUP',
  Fanadise: 'FAN',
  NFTrade: 'NFTD',
  'Coin Discovery': 'CODI',
  MMACOIN: 'MMA',
  BlackPool: 'BPT',
  NiiFi: 'NIIFI',
  Velox: 'VLX',
  Immutable: 'DARA',
  Cogecoin: 'COGE',
  NAGA: 'NGC',
  MemePad: 'MEPAD',
  Cryptomeda: 'TECH',
  'Parallel Protocol': 'MIMO',
  pETH18C: 'pETH18C',
  IVOGEL: 'IVG',
  UniWhales: 'UWL',
  Polylauncher: 'ANGEL',
  'Quantfury Token': 'QTF',
  Intersola: 'ISOLA',
  'DEGEN Index': 'DEGEN',
  'DailySwap Token': 'DAILYS',
  Vendit: 'VNDT',
  SYL: 'SYL',
  Jointer: 'JNTR',
  'KCC MemePad': 'KCCM',
  Amasa: 'AMAS',
  'Game Ace Token': 'GAT',
  BitBook: 'BBT',
  'DEFI Top 5 Tokens Index': 'DEFI5',
  'Jack Token': 'JACK',
  'Waves Ducks': 'EGG',
  MeconCash: 'MCH',
  SafeMars: 'SMARS',
  CroxSwap: 'CROX',
  FansCoin: 'FC',
  'BabyDoge ETH': 'BABYDOGE',
  'Polycat Finance': 'FISH',
  SuperWhale: 'WAROO',
  Ki: 'XKI',
  'Jetfuel Finance': 'FUEL',
  'BabyETH V2': 'BabyETHV2',
  TasteNFT: 'TASTE',
  CellETF: 'ECELL',
  Earnable: 'EARN',
  SUP: 'SUP',
  'Meter Governance mapped by Meter.io': 'eMTRG',
  DeFi11: 'D11',
  Pitbull: 'PIT',
  BlockNoteX: 'BNOX',
  'Donnie Finance': 'DON',
  GazeTV: 'GAZE',
  YDragon: 'YDR',
  'Fortress Lending': 'FTS',
  'Annex Finance': 'ANN',
  'XUSD Stable': 'XUSD',
  TripCandy: 'CANDY',
  Medicalveda: 'MVEDA',
  'Moss Carbon Credit': 'MCO2',
  'Whale Fall': 'Whale',
  'PolyShield Finance': 'SHI3LD',
  '3X Long Altcoin Index Token': 'ALTBULL',
  'Wallet Swap': 'WSWAP',
  Tycoon: 'TYC',
  'Lox Network': 'LOX',
  'ZCore Finance': 'ZEFI',
  'Bonus Cake': 'BonusCake',
  Chainsquare: 'CHS',
  'Farmland Protocol': 'FAR',
  'Coinbase tokenized stock FTX': 'COIN',
  TreeDefi: 'SEED',
  SolanaSail: 'SAIL',
  'Bagels Finance': 'BAGEL',
  SpiderDAO: 'SPDR',
  FlokiFrunkPuppy: 'FLOKIFRUNKPUPPY',
  NEXTYPE: 'NT',
  'RobiniaSwap Token': 'RBS',
  'Keysians Network': 'KEN',
  'Lucky Unicorn Token': 'L99',
  Kulupu: 'KLP',
  'Round Dollar': 'RD',
  'Unit Protocol Duck': 'DUCK',
  '3x Short EOS Token': 'EOSBEAR',
  Decimal: 'DEL',
  Alchemy: 'ACOIN',
  'Winwinwin Project': 'WWIN',
  Sypool: 'SYP',
  'LITTLE RABBIT': 'LTRBT',
  'Kaiken Inu': 'KAIECO',
  Equilibrium: 'EQ',
  'Cub Finance': 'CUB',
  'Bitrise Token': 'BRISE',
  'Beach Token': 'BEACH',
  Feyorra: 'FEY',
  CatBread: 'CATBREAD',
  TOZEX: 'TOZ',
  Tokenplace: 'TOK',
  'Digital Fitness': 'DEFIT',
  DEFFECT: 'DEF',
  KittyCake: 'KCAKE',
  'Rebasing Liquidity': 'DELTA-RLP',
  'Steam Exchange': 'STEAMX',
  ATTN: 'ATTN',
  LBK: 'LBK',
  CaliCoin: 'CALI',
  WifeDoge: 'WIFEDOGE',
  Modex: 'MODEX',
  'SaunaFinance Token': 'SAUNA',
  'Revest Finance': 'RVST',
  'Copiosa Coin': 'COP',
  WiBX: 'WBX',
  'Karma DAO': 'KARMA',
  'JUST NETWORK': 'JUS',
  Tenshi: 'TENSHI',
  UNCL: 'UNCL',
  Epanus: 'EPS',
  'governance ZIL': 'GZIL',
  'Lung Protocol': 'L2P',
  Radar: 'RADAR',
  'Shih Tzu': 'SHIH',
  NearPad: 'PAD',
  ELONGATE: 'ELONGATE',
  'Blizzard.money': 'xBLZD',
  'Bankless BED Index': 'BED',
  'Hungarian Vizsla Inu': 'HVI',
  Astronaut: 'NAUT',
  'V-Dimension': 'VOLLAR',
  'Daddy Doge': 'DADDYDOGE',
  Sensitrust: 'SETS',
  BuffaloSwap: 'BUFF',
  EverestCoin: 'EVCOIN',
  Hope: 'HOPE',
  Corgiswap: 'CORIS',
  Sashimi: 'SASHIMI',
  'Bitcashpay (new)': 'BCP',
  Vera: 'VERA',
  KuSwap: 'KUS',
  Billion: 'BILL',
  Matrixswap: 'MATRIX',
  Goldblock: 'GBK',
  'Chopper Inu': 'CHOPPER',
  'Griffin Art': 'GART',
  SAFETREES: 'TREES',
  TruBadger: 'TRUBGR',
  'RichQUACK.com': 'QUACK',
  GUARDIAN: 'GUARD',
  'Big Digital Shares': 'BDS',
  TeraBlock: 'TBC',
  Husky: 'HUSKY',
  Identity: 'IDTT',
  'Safe Star': 'SAFESTAR',
  'Golden Token': 'GOLD',
  BEUROP: 'BEPR',
  NiftyNFT: 'NIFTY',
  'GOKU INU': 'GOKU',
  DefiDollar: 'DUSD',
  'Inter Milan Fan Token': 'INTER',
  Stater: 'STR',
  'Blocks Space': 'BLS',
  Moonlana: 'MOLA',
  Bonfire: 'BONFIRE',
  'Spain National Fan Token': 'SNFT',
  TruePNL: 'PNL',
  NftyPlay: 'POLO',
  Agrinoble: 'AGN',
  'Cure Token': 'CURE',
  Unipilot: 'PILOT',
  Orakuru: 'ORK',
  CELEBPLUS: 'CELEB',
  'Pledge Coin': 'PLG',
  Hintchain: 'HINT',
  'United Bitcoin': 'UBTC',
  'YAM V2': 'YAMV2',
  BankerDoge: 'BANKER',
  Woofy: 'WOOFY',
  'hi Dollar': 'HI',
  'Tessla Coin': 'TSLA',
  'Compound Basic Attention Token': 'CBAT',
  xDAI: 'xDAI',
  Raptoreum: 'RTM',
  MilkshakeSwap: 'Milk',
  'JINDO INU': 'JIND',
  'OEC FIL': 'FILK',
  DFOhub: 'BUIDL',
  NFTBlackMarket: 'NBM',
  '3x Short Litecoin Token': 'LTCBEAR',
  Mars: 'Mars',
  'Black Eye Galaxy': 'BYG',
  'Sentiment Token': 'SENT',
  'HAPY Coin': 'HAPY',
  BLOCKMAX: 'OCB',
  Megatech: 'MGT',
  'Summit Koda Token': 'KODA',
  'Paralink Network': 'PARA',
  Bone: 'BONE',
  Ultrasafe: 'ULTRA',
  'NFT STARS': 'NFTS',
  'BULL FINANCE': 'BULL',
  EDDASwap: 'EDDA',
  'iOWN Token': 'iOWN',
  'DoveSwap Finance': 'DOVE',
  Trustworks: 'TRUST',
  Ethermon: 'EMON',
  'Floki Shiba': 'FSHIB',
  ArbiNYAN: 'NYAN',
  'USD Open Dollar': 'USDO',
  'Buni Universal Reward': 'BUR',
  'Solpad Finance': 'SOLPAD',
  'Voice Token': 'VOICE',
  'Moonfarm Finance': 'MFO',
  AstroElon: 'ELONONE',
  MobiFi: 'MoFi',
  'Xenon Pay': 'X2P',
  Booster: 'BOO',
  Glimpse: 'GLMS',
  Beldex: 'BDX',
  'Buffer Finance': 'IBFR',
  'Bright Union': 'BRIGHT',
  MoonX: 'MoonX',
  GrimToken: 'GRIM',
  SafeBitcoin: 'SAFEBTC',
  LavaSwap: 'LAVA',
  'delta.theta': 'DLTA',
  'PureFi Protocol': 'UFI',
  Axion: 'AXN',
  'Jenny Metaverse DAO Token': 'UJENNY',
  Multicoin: 'MTCN',
  'Baby Shiba': 'BHIBA',
  'Safe Earn': 'SAFEARN',
  Nabox: 'NABOX',
  'Yield Parrot': 'LORY',
  'Hesh.Fi': 'HESH',
  'Kaiju Worlds': 'KAIJU',
  FingerprintsDAO: 'PRINTS',
  'Shabu Shabu Finance': 'KOBE',
  Kabosu: 'KABOSU',
  '1X Short XRP Token': 'XRPHEDGE',
  'FRMx Token': 'FRMX',
  Verse: 'VERSE',
  ToolApe: 'TAPE',
  'Float Protocol: Float': 'FLOAT',
  Orica: 'ORI',
  Temtum: 'TEM',
  'Mensa Protocol': 'MENSA',
  'Magic Power': 'MGP',
  FarmersOnly: 'CORN',
  'One Cash': 'ONC',
  CORN: 'CORN',
  'Cryptocurrency Top 10 Tokens Index': 'CC10',
  'Gains Associates': 'GAINS',
  B20: 'B20',
  Swampy: 'SWAMP',
  'Munch Token': 'MUNCH',
  BlackDragon: 'BDT',
  'Stronghold Token': 'SHX',
  Caliente: 'CAL',
  UnderMineGold: 'UMG',
  'Mobius Finance': 'MOT',
  BabyArmy: 'BARMY',
  Baitcoin: 'BAIT',
  'Token TKX': 'TKX',
  KelVPN: 'KEL',
  MCFinance: 'MCF',
  'Matic Aave Interest Bearing USDC': 'MAUSDC',
  'BarbecueSwap Finance': 'BBQ',
  Useless: 'USELESS',
  'Based Gold': 'BGLD',
  'OMNI - People Driven': 'OMN',
  'Evanesco Network': 'EVA',
  'Experty Wisdom Token': 'WIS',
  'Decentralized Community Investment Protocol': 'DCIP',
  Emblem: 'EMB',
  'Cryption Network': 'CNT',
  'Baby Saitama Inu': 'BABYSAITAMA',
  'Dapp Token': 'DAPPT',
  UniDex: 'UNIDX',
  Bitcrush: 'CRUSH',
  'Lydia Finance': 'LYD',
  'Storm Token': 'STORM',
  'Wault [New]': 'WAULTX',
  'WHEAT Token': 'WHEAT',
  'yffi finance': 'YFFI',
  'Mini Shiba': 'MINISHIBA',
  MyBricks: '$BRICKS',
  Pampther: 'PAMPTHER',
  Cybertronchain: 'CTC',
  'Akropolis Delphi': 'ADEL',
  Behodler: 'EYE',
  Burp: 'BURP',
  'YEL.Finance': 'YEL',
  'Bankless DAO': 'BANK',
  UCX: 'UCX',
  'Alita Finance': 'ALI',
  'junca Cash': 'JCC',
  'Boo Finance': 'BOOFI',
  'Royal Protocol': 'ROY',
  'Golden Doge': 'GDOGE',
  Mainston: 'STON',
  BUMooN: 'BUMN',
  'Basis Gold': 'BAG',
  'Black Diamond Rating': 'HZT',
  'Aidi Finance': 'AIDI',
  Freela: 'FREL',
  'Renascent Finance': 'RENASCENT',
  'iTrust.Finance': 'ITG',
  AlinX: 'ALIX',
  'Miners Defi': 'MINERS',
  Avaware: 'AVE',
  'Deku Inu': 'DEKU',
  TheFutbolCoin: 'TFC',
  CumInu: 'CUMINU',
  'LIQ Protocol': 'LIQ',
  Dexioprotocol: 'DEXI',
  '3x Short XRP Token': 'XRPBEAR',
  YetiSwap: 'YTS',
  'CLIMB TOKEN FINANCE': 'CLIMB',
  'Release Project': 'REL',
  FreeRiver: 'FREE',
  'Smart Wallet Token': 'SWT',
  '3X Long Huobi Token Token': 'HTBULL',
  CHAINFI: 'CNFI',
  'Solyard Finance': 'YARD',
  'Bitcoin Bam': 'BTCBAM',
  'Lofi Defi': 'LOFI',
  Locklet: 'LKT',
  Wolfystreetbets: 'WOLFY',
  'Mondo Community Coin': 'MNDCC',
  'Fire Protocol': 'FIRE',
  'Bandot Protocol': 'BDT',
  'My DeFi Legends': 'DLEGENDS',
  'Alpaca City': 'ALPA',
  SaylorMoon: 'SMOON',
  'ROPE Token': 'ROPE',
  'Health Potion': 'HEP',
  REBIT: 'KEYT',
  'ArchAngel Token': 'ARCHA',
  nHBTC: 'N0001',
  WHITEX: 'WHX',
  MuskSwap: 'MUSK',
  'Xiasi Inu': 'XIASI',
  Kevacoin: 'KVA',
  'Wifi Coin': 'WIFI',
  'Dcoin Token': 'DT',
  'Electric Arena': 'EARENA',
  'FOMO LAB': 'FOMO',
  '12Ships': 'TSHP',
  'Armor NXM': 'arNXM',
  'Tsuki Inu': 'TKINU',
  DGPayment: 'DGP',
  'Travel Care': 'TRAVEL',
  DOJO: 'DOJO',
  'Electric Vehicle Direct Currency': 'EVDC',
  DAppNode: 'NODE',
  GogolCoin: 'GOL',
  'QUAI DAO': 'QUAI',
  LockTrip: 'LOC',
  Dino: 'DINO',
  'GIBX Swap': 'X',
  'Solster Finance': 'STR',
  'GameFi Shiba': 'GAMEFI',
  'HiFi Gaming Society': 'HIFI',
  CherryPick: 'CHERRY',
  'Block Ape Scissors': 'BAS',
  'HIPPO TOKEN': 'HIP',
  JFIN: 'JFC',
  'Forest Knight': 'KNIGHT',
  'Connect Financial': 'CNFI',
  'Kingdom Coin': 'KDC',
  'MoMo KEY': 'KEY',
  'Supersonic Finance': 'SSN',
  EcoFi: 'ECO',
  Retreeb: 'TREEB',
  'Billibilli tokenized stock Bittrex': 'BILI',
  'SafeCap Token': 'SFC',
  'Your Future Exchange': 'YFX',
  'Metaverse Miner': 'META',
  MaidCoin: '$MAID',
  OLYMPUS: 'OLYMPUS',
  VELOREX: 'VEX',
  Binamars: 'BMARS',
  Snook: 'SNK',
  'D Community': 'DILI',
  TakoDefi: 'TAKO',
  'TON Coin': 'TONCOIN',
  'Husky Avax': 'HUSKY',
  'Atlantic Finance Token': 'ATFI',
  '888tron': '888',
  'BitoPro Exchange Token': 'BITO',
  'Tesla tokenized stock FTX': 'TSLA',
  Strite: 'STRI',
  MDUKEY: 'MDU',
  Zerogoki: 'REI',
  'Black Lemon': 'BOM',
  Vinci: 'VINCI',
  'Cream ETH 2': 'CRETH2',
  LITUNI: 'LITO',
  Arcona: 'ARCONA',
  'SYA x Flooz': 'SYA',
  'CRIR MSH': 'MSH',
  TetherBlack: 'TTB',
  Gooreo: 'GOOREO',
  MaskDoge: 'MASKDOGE',
  QURAS: 'XQC',
  'Force For Fast': 'FFF',
  'ARTH [polygon]': 'ARTH',
  Phuture: 'PHTR',
  ACryptoS: 'ACS',
  DeHero: 'HEROES',
  Mindsync: 'MAI',
  'LoserChick EGG': 'EGG',
  'OpenAlexa Protocol': 'OAP',
  'Creator Platform': 'CTR',
  '3x Long Bitcoin Cash Token': 'BCHBULL',
  xxxNifty: 'NSFW',
  MINDOL: 'MIN',
  'Boring Protocol': 'BOP',
  Moonbet: 'MBET',
  'Liquidity Dividends Protocol': 'LID',
  Impermax: 'IMX',
  Yucreat: 'YUCT',
  PearZap: 'PEAR',
  'Comodo Coin': 'CMD',
  DogeBack: 'DOGEBACK',
  'Unreal Finance': 'UGT',
  Rentible: 'RNB',
  REDi: 'REDI',
  'Pinecone Finance': 'PCT',
  'Evai.io': 'EVAI',
  BeeKan: 'BKBT',
  'Crusaders of Crypto': 'CRUSADER',
  PolkaMonster: 'PKMON',
  'Try.Finance': 'TRY',
  SpaceGrime: 'GRIMEX',
  PinkSale: 'PINKSALE',
  BaTorrent: 'BA',
  'Zoo Token': 'ZOOT',
  'Satopay Network': 'STOP',
  'Scan DeFi': 'SCAN',
  'Jubi Token': 'JT',
  eBlockStock: 'EBSO',
  TEAL: 'TEAT',
  Satozhi: 'SATOZ',
  HaggleX: 'HAG',
  'Yuan Chain Coin': 'YCC',
  ChainCade: 'CHAINCADE',
  ZORT: 'ZORT',
  LabraCoin: 'LABRA',
  Syfin: 'SYF',
  PlanetWatch: 'PLANETS',
  WIVA: 'WIVA',
  SafeVault: 'VAULT',
  Baanx: 'BXX',
  'Realfinance Network': 'REFI',
  'Xiglute Coin': 'XGC',
  Crystal: 'CRYSTAL',
  'APY Vision': 'VISION',
  'CSP DAO': 'NEBO',
  'Moon Warriors': 'MWAR',
  'Ape-X': 'APE-X',
  Eloin: 'ELOIN',
  'SOLA Token': 'SOLA',
  'Honey Token': 'SWEET',
  Freecash: 'FCH',
  BeatBind: 'BBND',
  DeFiPie: 'PIE',
  Altrucoin: 'ALTRUCOIN',
  OBORTECH: 'OBOT',
  Avakus: 'AVAK',
  Prelax: 'PEA',
  'Baby Doug': 'BABYDOUG',
  Dreamr: 'DMR',
  'Merchant Token': 'MTO',
  'DAO Invest': 'VEST',
  'MGC Token': 'MGC',
  EHash: 'EHASH',
  XMINE: 'XMN',
  'Night Life Crypto': 'NLIFE',
  Railgun: 'RAIL',
  'MCS Token': 'MCS',
  'iNFT Platform': 'INFT',
  'Sheesha Finance [BEP20]': 'SHEESHA',
  KickPad: 'KPAD',
  Didcoin: 'DID',
  'Octane Finance': 'OCTANE',
  GameX: 'GMX',
  'Mirrored Google': 'mGOOGL',
  'Alibaba tokenized stock FTX': 'BABA',
  Carrot: 'CRT',
  'IceSlush Finance': 'SLUSH',
  'Hachiko Inu': 'INU',
  Upfire: 'UPR',
  'Pacific DeFi': 'PACIFIC',
  'Rocket Launchpad': 'RCKT',
  'SWAPP Protocol': 'SWAPP',
  'YFi Management': 'YEFIM',
  'Elastic BNB': 'XBN',
  Corgidoge: 'CORGI',
  IAGON: 'IAG',
  'Flux Protocol': 'FLUX',
  'Deez Nuts': 'DEEZNUTS',
  'Ainu Token': 'AINU',
  'iBG Finance': 'IBG',
  'XGOLD COIN': 'XGOLD',
  'NFT SolPad': 'NFTSOL',
  TosDis: 'DIS',
  'Momo Protocol': 'MOMO',
  'GameFi Protocol': 'GFI',
  renFIL: 'RENFIL',
  'Keep3r BSC Network': 'KP3RB',
  Proxy: 'PRXY',
  'Total Crypto Market Cap Token': 'TCAP',
  SwapDEX: 'SDX',
  TABANK: 'TAB',
  'Defi Shopping Stake': 'DSS',
  EurocoinToken: 'ECTE',
  SafeHamsters: 'SAFEHAMSTERS',
  Alpha5: 'A5T',
  KEY: 'KEY',
  Polyroll: 'ROLL',
  'Financial Intelligence Group': 'ATBFIG',
  'Electric Cash': 'ELCASH',
  'OEC SHIB': 'SHIBK',
  'Pussy Financial': 'PUSSY',
  BasketCoin: 'BSKT',
  'Bezoge Earth': 'BEZOGE',
  'Sway Social Protocol': 'SWAY',
  'Pippi Finance': 'PIPI',
  'Mu Continent': 'MU',
  'PhoenixDefi.Finance': 'PNIX',
  "The People's Coin": 'PEEPS',
  'Mini Cardano': 'MADA',
  'Dogecoin 2.0': 'DOGE2',
  Shardus: 'ULT',
  'Oculus Vision': 'OCV',
  Theos: 'THEOS',
  GYSR: 'GYSR',
  Solberg: 'SLB',
  'Okex Fly': 'OKFLY',
  Mogu: 'MOGX',
  xToken: 'XTK',
  'The Everlasting Parachain': 'ELP',
  'The Employment Commons Work Token': 'WORK',
  'Pera Finance': 'PERA',
  Scaleswap: 'SCA',
  'Basis Dollar Share': 'BSDS',
  Vancat: 'VANCAT',
  'Taxa Token': 'TXT',
  Mozik: 'MOZ',
  Liquidifty: 'LQT',
  DangerMoon: 'DANGERMOON',
  ACryptoSI: 'ACSI',
  HoneyFarm: 'BEAR',
  Arix: 'ARIX',
  ShineChain: 'SHE',
  ShibaRocket: 'SHIBAROCKET',
  ETHVault: 'ETHVAULT',
  'Kelpie Inu': 'KELPIE',
  Cryptokek: 'KEK',
  'bDollar Share': 'SBDO',
  X3Swap: 'X3S',
  LinkToken: 'LTK',
  'Duel Network': 'DUEL',
  Voltage: 'VOLT',
  'Healing Potion': 'HPPOT',
  'Super Bitcoin': 'SBTC',
  'Tianyu Finance': 'TYC',
  SwapAll: 'SAP',
  'PUML Better Health': 'PUML',
  "Don't KYC": 'DKYC',
  Varen: 'VRN',
  Sekuritance: 'SKRT',
  AstroDoggy: 'ADOG',
  KRoot: 'KROOT',
  DefPace: 'DPACE',
  'Exen Coin': 'EXEN',
  'The Rare Antiquities Token': 'RAT',
  'Google tokenized stock Bittrex': 'GOOGL',
  Solminter: 'SMRT',
  Memenopoly: 'MNOP',
  'Shield Network': 'SHIELDNET',
  'Sovi Finance': 'SOVI',
  'URG University': 'URG-U',
  Swop: 'SWOP',
  DekBox: 'DEK',
  'Genesis Pool': 'GPOOL',
  DAOhaus: 'HAUS',
  Rivex: 'RVX',
  DefiXBet: 'DXB',
  LYFE: 'LYFE',
  VikingsChain: 'VIKC',
  Shibaverse: 'VERSE',
  Vention: 'VENTION',
  Zinari: 'ZINA',
  Aloha: 'ALOHA',
  'KONG Land': '$CITIZEN',
  Moonshot: 'MOONSHOT',
  BurnDoge: 'BURNDOGE',
  'DFX Finance': 'DFX',
  'Super Floki': 'SLOKI',
  'Egoras (New)': 'EGR',
  'REWARD HUNTERS TOKEN': 'RHT',
  'Alium Finance': 'ALM',
  Magicland: 'MAGIC',
  Combo: 'COMB',
  Scientix: 'SCIX',
  'Smile Coin': 'SMILE',
  'My Farm Pet': 'MYFARMPET',
  ShibaCorgi: 'SHICO',
  ORO: 'ORO',
  Nadeshiko: 'NDSK',
  DataHighway: 'DHX',
  Chainpay: 'CPAY',
  'Mini Floki': 'MINIFLOKI',
  Ballswap: 'BSP',
  BurningMoon: 'BM',
  BiTToken: 'BITT',
  'VATICAN FINANCE': 'VAT',
  bUKHI: 'BUKH',
  'United Farmers Finance': 'UFF',
  'DOOS TOKEN': 'DOOS',
  ethArt: 'ARTE',
  'Lever Token': 'LEV',
  'Unity Protocol': 'UNITY',
  DogemonGo: 'DOGO',
  'OVERLORD GAME': 'OVL',
  'Infinity Token': 'IT',
  BSCEX: 'BSCX',
  DACC: 'DACC',
  TokenAsset: 'NTB',
  bDollar: 'BDO',
  Sarcophagus: 'SARCO',
  'Ludos Protocol': 'LUD',
  'HakunaMatata (new)': 'HKUN',
  PinkPanda: 'PINKPANDA',
  'X-Block': 'IX',
  OASISBloc: 'OSB',
  RugZombie: 'ZMBE',
  'Fantom Doge': 'RIP',
  'Chihua Token': 'CHIHUA',
  DogePepsi: 'DOGEPEPSI',
  'Bancor Governance Token': 'VBNT',
  MoonStar: 'MOONSTAR',
  Olecoin: 'OLE',
  'Zytara dollar': 'ZUSD',
  Thales: 'THALES',
  'Inverse Bitcoin Volatility Token': 'IBVOL',
  'Dogey-Inu': 'DINU',
  'Hey Bitcoin': 'HYBN',
  Wanderlust: 'WANDER',
  'Charizard Token': 'CHZ006',
  'IFOSwap Token': 'H2O',
  ZoidPay: 'ZPAY',
  AurusDeFi: 'AWX',
  CAGE: 'C4G3',
  FUFU: 'FUFU',
  renZEC: 'RENZEC',
  TETU: 'TETU',
  FarmHero: 'HERO',
  'Papp Mobile': 'PAPP',
  'XTRA Token': 'XTRA',
  'Bake Coin': 'BAKECOIN',
  EverETH: 'EVERETH',
  'Darwinia Crab Network': 'CRAB',
  Evodefi: 'GENX',
  'Museum of Crypto Art': 'MOCA',
  'PURR Vault (NFTX)': 'PURR',
  'BUILD Finance': 'BUILD',
  'Bitsten Token': 'BST',
  'Mandala Exchange Token': 'MDX',
  SmartX: 'SAT',
  CrossSwap: 'CSWAP',
  'Galaxy Adventure': 'GLA',
  MegaCryptoPolis: 'MEGA',
  Engine: 'EGCC',
  Mammon: 'MMON',
  'Fisco Coin': 'FSCC',
  '4ART Coin': '4ART',
  YaySwap: 'YAY',
  BitcoinX: 'BCX',
  'Blockchain Quotations Index Token': 'BQT',
  'Matic Aave Interest Bearing WETH': 'MAWETH',
  'BABY DOGE INU': '$BABYDOGEINU',
  'Binance VND': 'BVND',
  'JD Coin': 'JDC',
  'Fox Finance': 'FOX',
  StaySAFU: 'SAFU',
  Bincentive: 'BCNT',
  MaticVerse: 'Mverse',
  Kauri: 'KAU',
  'Pet Games': 'PETG',
  ReFork: 'EFK',
  Uniqly: 'UNIQ',
  'Fantom Oasis': 'FTMO',
  FlatSwap: 'FSWAP',
  EduCoin: 'EDU',
  Plethori: 'PLE',
  Eclipse: 'ECP',
  TKBToken: 'TKB',
  'DrakeBall Token': 'DBALL',
  'Carbon Coin': 'CBC',
  AutoShark: 'JAWS',
  'VinDax Coin': 'VD',
  UCoin: 'UCOIN',
  Gameology: 'GMYX',
  'Crypto Raiders': 'AURUM',
  LCG: 'LCG',
  FOCV: 'FOCV',
  'American Shiba': 'USHIBA',
  'Fire Token': 'FIRE',
  'Blockchain Exchange Alliance': 'BXA',
  'WAIV Care': 'WAIV',
  Manyswap: 'MANY',
  'KRYZA Network': 'KRN',
  ADAFlect: 'ADAFLECT',
  DEI: 'DEI',
  'Web Coin Pay': 'WEC',
  MerchDAO: 'MRCH',
  Sherpa: 'SHERPA',
  'Unknown Fair Object': 'UFO',
  Rinnegan: 'REN',
  Promodio: 'PMD',
  'Evolution Finance': 'EVN',
  Melalie: 'MEL',
  Swaperry: 'PERRY',
  MintySwap: 'MINTYS',
  'The Grand Banks': 'GRAND',
  'SUPER MARIO': 'MARIO',
  CardWallet: 'CW',
  'Black Diamond': 'DIAMONDS',
  Calypso: 'CYO',
  'Moon Stop': 'MNSTP',
  'Hyperchain X': 'HYPER',
  InfinityCake: 'INCAKE',
  'FINANCIAL INVESTMENT TOKEN': 'FIT',
  Vidiachange: 'VIDA',
  BabySpaceFloki: 'BSF',
  'Zeropay Finance': 'ZEROPAY',
  Future1coin: 'F1C',
  '3x Long Bitcoin SV Token': 'BSVBULL',
  UMI: 'UMI',
  'Tamy Token': 'TMT',
  'AMPnet Asset Platform and Exchange': 'AAPX',
  CryptoCart: 'CC',
  vBSWAP: 'VBSWAP',
  'BlockSwap Network': 'CBSN',
  Gstcoin: 'GST',
  AK12: 'AK12',
  RugSeekers: 'SEEK',
  BIXBCOIN: 'BIXB',
  TreasureKey: 'PIRATE',
  'Nyan V2': 'NYAN-2',
  'Butterfly Protocol': 'BFLY',
  'Kephi Gallery': 'KPHI',
  AlgoVest: 'AVS',
  'Basis Share': 'BAS',
  OS: 'OS',
  MiniSwap: 'MINI',
  'Nobunaga Tokenas const, NBNG': 'NBNG',
  'moonwolf.io': 'WOLF',
  Nftfy: 'NFTFY',
  'Intelligent Investment Chain': 'IIC',
  Puriever: 'PURE',
  Cryptochrome: 'CHM',
  'Alpha Kombat': 'ALKOM',
  'Community Doge Coin': 'CCDOGE',
  'DeFi Factory Token': 'DEFT',
  DigiFinexToken: 'DFT',
  'Medican Coin': 'MCAN',
  'Aquarius Protocol': 'AQU',
  '3X Long Ethereum Classic Token': 'ETCBULL',
  UltimoGG: 'ULTGG',
  LinkPool: 'LPL',
  'Bali Coin': 'BALI',
  Hashmasks: 'MASK20',
  Ecochaintoken: 'ECT',
  Trodl: 'TRO',
  'Eco Value Coin': 'EVC',
  'Bond Appetite USD': 'USDAP',
  peachfolio: 'PCHF',
  'NVIDIA tokenized stock FTX': 'NVDA',
  KangarooCake: 'KCAKE',
  'Piggy Bank Token': 'PIGGY',
  'Itchiro Games': 'JEM',
  'Dopple Finance': 'DOP',
  '3X Long TomoChain Token': 'TOMOBULL',
  'Baby Alpaca': 'BALPAC',
  DoDreamChain: 'DRM',
  '3X Long Shitcoin Index Token': 'BULLSHIT',
  'HashBridge Oracle': 'HBO',
  'NFTMart Token': 'NMT',
  'RFOX Finance': 'VFOX',
  'Catge coin': 'CATGE',
  'CoinMetro Token': 'XCM',
  'Polly DeFi nest': 'NDEFI',
  'One Basis Cash': 'OBS',
  'Dogira (new)': 'DOGIRA',
  'TideBit Token': 'TBT',
  Herobattle: 'HRB',
  CumStar: 'CUMSTAR',
  OptionPanda: 'OPA',
  'SIL.FINANCE': 'SIL',
  'Sensible.Finance': 'SENSI',
  ForeverFOMO: 'FOREVERFOMO',
  VICEWRLD: 'VICE',
  'Blockmason Link': 'BLINK',
  'YouLive Coin': 'UC',
  Vanity: 'VNY',
  Steel: 'STEEL',
  Ourglass: 'GLASS',
  Beanstalk: 'BEAN',
  'Foxy Equilibrium': 'Foxy',
  Aurum: 'AUR',
  'ROCKSTAR DOGE': 'ROCKSTAR',
  'OneSwap DAO Token': 'ONES',
  DeFIRE: 'CWAP',
  'Art Blocks Curated Full Set': 'ABC123',
  'Bafe io': 'BAFE',
  Momento: 'MOMENTO',
  '3X Short Ethereum Token': 'ETHBEAR',
  Rare: 'RARE',
  Prostarter: 'PROT',
  upBNB: 'UPBNB',
  '3X Long Midcap Index Token': 'MIDBULL',
  'Able Finance': 'ABLE',
  'BitUP Token': 'BUT',
  'Safe Energy': 'ENERGYX',
  RichCity: 'RICH',
  Mazzuma: 'MAZ',
  Zilswap: 'ZWAP',
  'Mofi Finance': 'MOFI',
  'Little Angry Bunny v2': 'LAB V2',
  EnterDAO: 'ENTR',
  Chintai: 'CHEX',
  MMAON: 'MMAON',
  'xNFT Protocol': 'XNFT',
  Tigerfinance: 'TIGER',
  xMARK: 'XMARK',
  Iron: 'IRON',
  'Largo Coin': 'LRG',
  'Mooncake Token': 'MOON',
  Myōbu: 'MYOBU',
  'Balloon-X': 'BLX',
  'Pyram Token': 'PYRAM',
  ShibaCash: 'SHIBACASH',
  Reflex: 'RFX',
  'Stable FIL': 'ONEFIL',
  'Chemix Ecology Governance Token': 'KUN',
  BigShortBets: 'BIGSB',
  Picipo: 'PICIPO',
  'Future Of Finance Fund': 'FFF',
  'Bullish AF': 'BULLAF',
  'Sphynx Token': 'SPHYNX',
  'Zcon Protocol': 'ZCON',
  'FXT Token': 'FXT',
  Influencer: 'IMI',
  'Elephant Money': 'ELEPHANT',
  MERCI: 'MERCI',
  MiniUSDC: 'MINIUSDC',
  'GARD Governance Token': 'GGT',
  'Unicap.finance': 'UCAP',
  EnreachDAO: 'NRCH',
  'Everest Token': 'EVRT',
  'Viking Swap': 'VIKING',
  IZE: 'IZE',
  Lyra: 'LYR',
  'Auric Network': 'AUSCM',
  Lonelyfans: 'LOF',
  Minisoccer: 'MINISOCCER',
  BattleRoyaleToken: 'BRTK',
  CheeseFry: 'CHEESE',
  'The Hash Speed': 'THS',
  'NFTD Protocol': 'NFTD',
  'Copycat Finance': 'COPYCAT',
  'BNS Token': 'BNS',
  'Nyan Finance': 'NYAN',
  'Moma Protocol': 'MOMAT',
  BasketDAO: 'BASK',
  'Poodl Token': 'POODL',
  'Nether NFT': 'NTR',
  'Promotion Coin': 'PC',
  'Pocket Doge': 'PDOGE',
  'HASH Token': 'HASH',
  'HNC COIN': 'HNC',
  'RiceFarm Token': 'RICE',
  BSocial: 'BINS',
  AVME: 'AVME',
  SuperFuel: 'SFUEL',
  ZEDXION: 'ZEDXION',
  'XXT-Token': 'XXT',
  BinaHunter: 'BHUNT',
  'Vee Finance': 'VEE',
  NFTTONE: 'TONE',
  LatteSwap: 'LATTE',
  Edge: 'EDGE',
  Portal: 'PORTAL',
  'Gaj Finance': 'GAJ',
  'Base Reward Token': 'BRT',
  'OXO.Farm': 'OXO',
  'RoboDoge Coin': 'ROBODOGE',
  TeslaSafe: 'TESLASAFE',
  Aurix: 'AUR',
  Foliowatch: 'FWATCH',
  'Hyper Pay': 'HPY',
  'SafuYield Protocol': 'SAFUYIELD',
  POTENT: 'PTT`',
  'Bitcoin Networks': 'BTCN',
  YAS: 'YAS',
  'Game X Change': 'EXP',
  'Art of War': '$AOW',
  'HummingBird Finance': 'HMNG',
  'Zombie Rising NFT': 'ZOMB',
  ThingsOperatingSystem: 'TOS',
  'Bitcoin File': 'BIFI',
  YFBitcoin: 'YFBTC',
  'SUCCESS INU': 'SUCCESS',
  'Crypto Carbon Energy': 'CYCE',
  'DEXTF Protocol': 'DEXTF',
  APWars: 'WGOLD',
  DogeWarrior: 'DWR',
  Zafira: 'ZFAI',
  'Recharge Finance': 'R3FI',
  'ExzoCoin 2.0': 'EXZO',
  Omlira: 'OML',
  HONEYPAD: '$HONEY',
  RedFEG: 'REDFEG',
  'Tiki Token': 'TIKI',
  Ziktalk: 'ZIK',
  'DOOiT Token': 'DOO',
  Octans: 'OCTA',
  DogeDrinks: 'DOGEDRINKS',
  Akoin: 'AKN',
  'Around Network': 'ART',
  BoozeDoge: 'BODO',
  DSYS: 'DSYS',
  R34P: 'R34P',
  SaferMoon: 'SAFERMOON',
  'Wrapped Arweave': 'WAR',
  'T.OS': 'TOSC',
  MeowSwap: 'MEOW',
  YSL: 'YSL',
  TetraHedra: 'TTH',
  Interfinex: 'IFEX',
  RedShiba: 'REDSHIBA',
  'Magic beasties': 'BSTS',
  'BSB Token': 'BSBT',
  Ecoin: 'ECOIN',
  Shrew: 'SHREW',
  'Kanaloa Network': 'KANA',
  'xWIN Finance': 'XWIN',
  'Interest Bearing Defi Pulse Index': 'BDPI',
  'FANBI TOKEN': 'FBT',
  'Grayscale Bitcoin Trust tokenized stock FTX': 'GBTC',
  ROBINOS: 'RBN',
  EmiSwap: 'ESW',
  'TrustFi Network': 'TFI',
  'FM Gallery': 'FMG',
  Communifty: 'CNFT',
  'Baby Pig Token': 'BABYPIG',
  Pika: 'PIKA',
  'Advanced Micro Devices tokenized stock FTX': 'AMD',
  Pastel: 'PSL',
  'Quam Network': 'QUAM',
  DOOR: 'DOOR',
  DaddyUSDT: 'DADDYUSDT',
  Dina: 'DINA',
  CaribMarsX: 'CMX',
  RamenSwap: 'RAMEN',
  'Cycle Finance': 'CYCLE',
  PremiumBlock: 'PRB',
  Emanate: 'EMT',
  Uhive: 'HVE2',
  GemBites: 'GBTS',
  Opennity: 'OPNN',
  'Non-Fungible TOKE': 'TOKE',
  Xriba: 'XRA',
  WasabiX: 'WASABI',
  'Zeppelin DAO': 'ZEP',
  Kurobi: 'KURO',
  Direwolf: 'DIREWOLF',
  SimpleChain: 'SIMPLE',
  EQO: 'EQO',
  'Sting Defi': 'SDFI',
  '3x Short Bitcoin SV Token': 'BSVBEAR',
  Cometh: 'MUST',
  'Vira-lata Finance': 'REAU',
  'The HUSL': 'HUSL',
  SafeMoonCash: 'SAFEMOONCASH',
  'Kiwi Finance': 'KIWI',
  Sucrecoin: 'XSR',
  'SILVER (SVS)': 'SVS',
  'YFIX Finance': 'YFIX',
  'Greenheart CBD': 'CBD',
  'CityStates: Medieval': 'CSM',
  NFTmall: 'GEM',
  Rhythm: 'RHYTHM',
  CoinMeet: 'MEET',
  'SHIB CAKE': 'SHIBCAKE',
  '1-UP': '1-UP',
  LEOPARD: 'LEOPARD',
  VersoView: 'VVT',
  EsportsPro: 'ESPRO',
  'Zasset zUSD': 'ZUSD',
  'Krypton Galaxy Coin': 'KGC',
  Ndau: 'NDAU',
  Ethbox: 'EBOX',
  'FEICHANG NIU': 'FCN',
  'Hugo Finance': 'HUGO',
  DashSports: 'DASS',
  'COPS FINANCE': 'COPS',
  'Somnium Space Cubes': 'CUBE',
  Potentiam: 'PTM',
  'Culture Ticket Chain': 'CTC',
  wanUSDC: 'WANUSDC',
  'Moonlight Token': 'MOONLIGHT',
  'Bingus Network': 'BINGUS',
  'CBET Token': 'CBET',
  Digible: 'DIGI',
  Vacay: 'VACAY',
  'Decentralized Nations': 'DENA',
  LedgerScore: 'LED',
  POP: 'POP!',
  'Degen Protocol': 'DGN',
  UNILAYERX: 'LAYERX',
  'Space Token': 'SPACE',
  WingShop: 'WING',
  'PieDAO DEFI Large Cap': 'DEFI+L',
  'Xpose Protocol': 'XP',
  'Life Token': 'LTN',
  PathFund: 'PATH',
  'Gods and Legends': 'GNLR',
  CrossFi: 'CRFI',
  MemeKiller: 'KILL',
  Perra: 'PERRA',
  'Moonarch.app': 'MOONARCH',
  Greenex: 'GNX',
  'PolygonFarm Finance': 'SPADE',
  MaticLaunch: 'MTCL',
  RARA: 'RARA',
  NEFTiPEDiA: 'NFT',
  'GM Holding': 'GM',
  JEDSTAR: 'JED',
  PolyQuity: 'PYQ',
  'Baby Starlink Doge': 'STARLINKDOGE',
  'ECHO TECH COIN': 'ECOT',
  'Dragon Slayer': 'DRS',
  'Unique One': 'RARE',
  'Sheesh it is bussin bussin': 'SHEESH',
  Koinos: 'KOIN',
  'JDI Yield': 'JDI',
  Pinknode: 'PNODE',
  'Octaplex Network': 'PLX',
  'Wrapped NCE': 'WNCE',
  xHunter: 'XHT',
  WHACKD: 'WHACKD',
  'TWO TWO': 'X22',
  Chicken: 'KFC',
  'YFOX FINANCE': 'YFOX',
  '1x Long Bitcoin Implied Volatility Token': 'BVOL',
  Rewardeum: 'REUM',
  LoserChick: 'CHICK',
  'New BTC': 'NBTC',
  'Monkey Token': 'MBY',
  Aquari: 'AQUARI',
  AurusGOLD: 'AWG',
  'UNIFI DeFi': 'UNIFI',
  'Decentralized Mining Exchange': 'DMC',
  'Toll Free Swap': 'TOLL',
  Pupper: 'PUP',
  'InvictusCapital.com Token': 'ICAP',
  Credmark: 'CMK',
  RimauSwap: 'RIMAU',
  Pantos: 'PAN',
  Zeedex: 'ZDEX',
  ccFound: 'FOUND',
  'Gondola Finance': 'GDL',
  DISCIPLINA: 'DSCPL',
  'Block Duelers NFT Battles': 'BDT',
  'SolDate Token': 'DATE',
  NanTrade: 'NAN',
  'YSL.IO': 'SYSL',
  BankEth: 'BANKETH',
  Elitheum: 'ELTHM',
  EveryApe: 'EVAPE',
  EIDOS: 'EIDOS',
  'Hibiki Finance': 'HIBIKI',
  'Seeder Finance': 'LEAF',
  H2Finance: 'YFIH2',
  IFToken: 'IFT',
  DFBTC: 'AOM',
  dFund: 'DFND',
  SERGS: 'SERGS',
  'Daopolis Token (DAOS)': 'DAOS',
  'Baby Bonfire': 'FIRE',
  QFinance: 'QFI',
  'Tena [new]': 'TENA',
  GRAP: 'GRAP',
  'Asia Reserve Currency Coin': 'ARCC',
  PeerEx: 'PERX',
  'SolarWind Token': 'SLW',
  '3X Short TRX Token': 'TRXBEAR',
  PantherSwap: 'PANTHER',
  SafeAffinity: 'AFFINITY',
  'Smart Trade Coin': 'TRADE',
  'EFT.finance': 'EFT',
  'SCV.finance Token': 'SCV',
  Erosswap: 'EROS',
  'LOVE EARTH COIN': 'LEC',
  BitSong: 'BTSG',
  Newinu: 'NEWINU',
  Yield: 'YLD',
  Sugarland: 'SUGAR',
  'GridZone.io': 'ZONE',
  'Unslashed Finance': 'USF',
  'Pandora Protocol': 'PNDR',
  Relevant: 'REL',
  'Rowan Token': 'RWN',
  StarbaseUniverse: 'SUNI',
  'Laser Eyes': 'LASEREYES',
  Reserve: 'RSV',
  'Fashion Coin': 'FSHN',
  'Binance Smart Chain Girl': 'BSCGIRL',
  Mixin: 'XIN',
  SheepToken: 'SHEEP',
  iLayer: 'ILAYER',
  Amorswap: 'AMOR',
  CheCoin: 'CHECOIN',
  'City Coin': 'CITY',
  'MicroStrategy tokenized stock FTX': 'MSTR',
  'Musashi Finance': 'MUS',
  XDAG: 'XDAG',
  AVAXTARS: 'AVXT',
  'Solomon Defi': 'SLM',
  'CFL 365 Finance': 'CFL365',
  'Kaiken Shiba': 'KSHIB',
  Mover: 'MOVE',
  FastSwap: 'FAST',
  Zipmex: 'ZMT',
  'NFT TOKEN PILOT': 'NFTP',
  'Baddest Alpha Ape Bundle': 'APED',
  'My Pet Social': 'MPS',
  'Dragon X': 'DAX',
  Pepedex: 'PPDEX',
  'Fungie DAO': 'FNG',
  'Shibaken Finance': 'SHIBAKEN',
  'Sphynx Network': 'SPH',
  'Polystarter.net': 'POLR',
  BIGFOOT: 'FOOT',
  Krill: 'KRILL',
  'THUNDERCAKE.APP': 'THUNDERCAKE',
  iBNB: 'IBNB',
  REALPAY: 'RAP',
  'Neeva Defi': 'NVA',
  'SeaDog Finance': 'SEAD',
  'Cryptographic Ultra Money': 'CUM',
  'Drip Network': 'DRIP',
  SpankChain: 'SPANK',
  'Robo Token': 'ROBO',
  SoPay: 'SOP',
  YOKcoin: 'YOK',
  Gomics: 'GOM',
  DeFinity: 'DEFX',
  DaddyYorkie: 'DDY',
  'XRE Global': 'XRE',
  'Block Creatures': 'MOOLAH',
  'Whirl Finance': 'WHIRL',
  'SOS Foundation': 'SOS',
  GoldFarm: 'GOLD',
  CARAT: 'CARAT',
  SaylorCake: 'SCAKE',
  'Cake Bank': 'CAKEBANK',
  WardenSwap: 'WAD',
  HappyCoin: 'HAPPY',
  'SoMee Advertising Token': 'SAT',
  'Dare Token': 'DRE',
  Dogmoon: 'DOGMOON',
  Theoscoin: 'THS',
  'Doge Universe': 'SPACEXDOGE',
  Tcake: 'TCAKE',
  'Papel Token': 'PAPEL',
  LemoChain: 'LEMO',
  'LOA Protocol': 'LOA',
  Dextoken: 'DEXG',
  DogeZoo: 'DZOO',
  'Jax Network': 'WJXN',
  'Safe money': 'SAFEMONEY',
  Amnext: 'AMC',
  'SheBollETH Commerce': 'SBECOM',
  Goldcoin: 'GLC',
  XFai: 'XFIT',
  InvestDex: 'INVEST',
  HappinessToken: 'HPS',
  Sombra: 'SMBR',
  'Billibilli Inc tokenized stock FTX': 'BILI',
  Shibance: 'WOOF',
  Rezerve: 'RZRV',
  'Advanced Internet Blocks': 'AIB',
  'STABLE ASSET': 'STA',
  SafeZone: 'SAFEZONE',
  'Ara Blocks': 'ARA',
  bitCEO: 'BCEO',
  'RISQ Protocol': 'RISQ',
  'Revo Network': 'REVO',
  Wenlambo: 'WENLAMBO',
  SteakBankFinance: 'SBF',
  'SPACE-iZ': 'SPIZ',
  KarenCoin: 'KAREN',
  'Cryptopia Land Dollar': 'CLD',
  'Mars Network': 'MARS',
  Mycro: 'MYO',
  'CyberTime Finance Token': 'CTF',
  'NCAT Token': 'NCAT',
  'Candela Coin': 'CLA',
  DAIN: 'DAIN',
  Oviex: 'OVI',
  'Milk Token': 'MILK',
  'Marsan Exchange token': 'MRS',
  'Zild Finance': 'ZILD',
  'Polly Finance': 'POLLY',
  Morpher: 'MPH',
  'Crypto Excellence': 'CE',
  'XBE Token': 'XBE',
  MoonToken: 'MOONTOKEN',
  HEdpAY: 'HDP.ф',
  VeraOne: 'VRO',
  'PUNK Floor': 'FLOOR',
  'Trade.win': 'TWI',
  GSENetwork: 'GSE',
  'UME Token': 'UME',
  HecoFi: 'HFI',
  BIOKKOIN: 'BKKG',
  'Mirrored Facebook Inc': 'mFB',
  'TUNE TOKEN': 'TUNE',
  'Facebook tokenized stock FTX': 'FB',
  CheeseSwap: 'CHS',
  Newsolution: 'NST',
  SAFESUN: 'SAFESUN',
  PolkaParty: 'POLP',
  DAO1: 'DAO1',
  'PieDAO DEFI Small Cap': 'DEFI+S',
  'WPP TOKEN': 'WPP',
  '3x Short Tezos Token': 'XTZBEAR',
  'Xrpalike Gene': 'XAG',
  Nodeseeds: 'NDS',
  'SoMee.Social': 'SOMEE',
  'ESR Coin': 'ESRC',
  'ApeXit Finance': 'APEX',
  Nectar: 'NEC',
  'Toy Doge Coin': 'TOYDOGE',
  Flits: 'FLS',
  'DEONEX COIN': 'DON',
  'Converter.Finance': 'CON',
  Arbucks: 'BUCK',
  Triall: 'TRL',
  'SOCIETY OF GALACTIC EXPLORATION': 'SGE',
  'Chronic Token': 'CHT',
  'Unicly Genesis MoonCats Collection': 'UGMC',
  'Ethereum Wrapped Filecoin': 'EFIL',
  United: 'UTED',
  AmazonasCoin: 'AMZ',
  Potato: 'POTATO',
  CPUcoin: 'CPU',
  'ZOD RUNE - Rune.Game': 'ZOD',
  'Amazon tokenized stock FTX': 'AMZN',
  'Ramifi Protocol': 'RAM',
  'Eternal Cash': 'EC',
  Unifund: 'IFUND',
  Bankcoin: 'BANK',
  'Apple tokenized stock FTX': 'AAPL',
  Attrace: 'ATTR',
  'BenePit Protocol': 'BNP',
  'Pundi X[old]': 'NPXS',
  Etheroll: 'DICE',
  Libonomy: 'LBY',
  'XPToken.io': 'XPT',
  'Vision Network': 'VSN',
  'Moonkafe Finance': 'KAFE',
  indaHash: 'IDH',
  Demodyfi: 'DMOD',
  LINA: 'LINA',
  'Alkemi Network DAO Token': 'ALK',
  'AMC Entertainment Holdings tokenized stock FTX': 'AMC',
  'GOGO.finance': 'GOGO',
  'Curio Governance': 'CGT',
  ECOChain: 'ECOC',
  Coalculus: 'COAL',
  Prepayway: 'InBit',
  BaconDAO: 'BACON',
  Spacelens: 'SPACE',
  'ZUZ Protocol': 'ZUZ',
  'SideShift Token': 'XAI',
  'Volatility Protocol Token': 'VOL',
  'Matic Aave Interest Bearing UNI': 'MAUNI',
  'Wrapped Conceal': 'WCCX',
  Jewel: 'JWL',
  'Dynamic Set Dollar': 'DSD',
  'happy birthday coin': 'HBDC',
  GMX: 'GMX',
  Draken: 'DRK',
  'SafeGem.Finance': 'GEMS',
  'Papa Shiba': 'PHIBA',
  'Crypto Bank Coin': 'CBC',
  'SPDR S&P 500 ETF tokenized stock FTX': 'SPY',
  'ANS Coin': 'ANS',
  YoCoin: 'YOCO',
  Litecash: 'CASH',
  'South African Tether': 'xZAR',
  'Crystl Finance': 'CRYSTL',
  'Fomo App': 'PAPER',
  'Steak Token': 'STEAK',
  Neumark: 'NEU',
  IOU: 'IOUX',
  Game1Network: 'GAME1',
  HyperGraph: 'HGT',
  'WorkQuest Token': 'WQT',
  'Excavo Finance': 'CAVO',
  April: 'APRIL',
  pSwampy: 'PSWAMP',
  '3x Short Bitcoin Cash Token': 'BCHBEAR',
  'Gambler Shiba': 'GSHIBA'
};
exports.symbolLookupObject = symbolLookupObject;